<template>
  <div class="page checkout">

    <!--<div class="absBack"> -->
    <!--           <div onclick="window.history.back()"> -->
    <!--                <v-icon medium dark>mdi-arrow-left</v-icon> -->
    <!--            </div> -->

    <!--        </div> -->

    <div class="onlyForHighScreens">&nbsp;</div>

    <div class="text-center" v-if="$store.getters.isKiosk">
      <h1 class="mt-7" style="margin-bottom: 2px;">
        <span>&nbsp;</span>
        <br>
        <span>Bestellung abschließen</span>
        <!--        <span>Nur noch ein Schritt..</span>-->
        <!--        <br>-->
        <!--        <span>&nbsp;</span>-->
      </h1>
      <h4 :class="{'mb-6': !$store.getters.isKiosk}">Gesamtsumme:
        <span class="textFont">{{ total | priceTotal }}</span>
      </h4>
      <h4 class="mb-6" v-if="$store.getters.isKiosk">
        Zahlung an der Kasse
      </h4>

    </div>

    <template v-else>
      <h2 class="text-center mt-7" style="margin-bottom: 2px;">Bestellung zur Abholung</h2>
      <div class="text-center">
        <!--            <h2 style="margin-bottom: 20px" v-if="usecase === 'takeAway'">Gesamtsumme: {{total | priceTotal}}</h2>-->
        <!--            <h2 style="margin-bottom: 20px" v-else>Gesamtsumme: {{total | priceTotal}}</h2>-->
        <h4 class="">Gesamtsumme: <span class="textFont">{{ total | priceTotal }}</span></h4>
        <h4 class="mb-6">Zahlung bei Abholung</h4>
        <!--            <div>Bestellen zum Abholen</div>-->
      </div>
    </template>

    <v-container class="ccontainer" grid-list-md>
      <!--        <v-container class="bigger-input" grid-list-md>-->

      <div class="kioskCheckoutContainer">
        <v-stepper v-model="currentStep" vertical class="vvd orderform" id="stepper">

          <v-stepper-step :complete="currentStep > 1" step="1" @click.native.passive="currentStep = 1">
            <div v-if="$store.getters.isKiosk" class="nice-title titleFont">Optional kannst du deinen Namen für die
              Abholung
              eingeben
            </div>
            <div v-else class="nice-title small">Deine Bestelldaten</div>
            <!--                    <div class="nice-title small">Bitte überprüfe deine Daten</div>-->
          </v-stepper-step>
          <v-stepper-content step="1">
            <!--                    <div v-if="!hasFd" class="hinweis">-->
            <!--                        &lt;!&ndash;                        <v-icon>mdi-information-variant</v-icon>&ndash;&gt;-->
            <!--                        <div>Deine Eingabe wird lokal gespeichert, um zukünftige Bestellungen zu erleichtern 👍</div>-->
            <!--                    </div>-->
            <!--                    <h4 class="mb-1" v-if="asGuest">Bestellung als Gast</h4>-->
            <div v-if="usecase.length > 0" id="checkData">
              <!--                        <h4>Überprüfe deine Daten&nbsp;&nbsp;<v-icon @click.passive.native="gotoAccount">mdi-pencil-->
              <!--                        </v-icon>-->
              <!--                        </h4>-->
              <div class="bestelldaten pt-1">

                <v-form v-show="showForm" @submit.prevent="" ref="orderDataForm" v-model="valid" lazy-validation>

                  <template v-if="$store.getters.isKiosk">
                    <v-text-field
                      outlined
                      v-model="name"
                      :label="(selfServiceEnabled) && !$store.getters.isKiosk ? 'Name*' : 'Name (optional)'"
                      :rules="nameRules"
                      placeholder="Name"
                      illed hide-details
                      @focus="nameFocus"
                      @blur="unhideToolbar"
                    ></v-text-field>

                    <h4 class="mt-4">Hinweise zur Bestellung</h4>
                    <v-text-field
                      outlined
                      hide-details
                      v-model="note"
                      class="nolabel"
                      clearable
                      illed
                      @focus="hinweisFocus"
                    ></v-text-field>
                  </template>

                  <template v-else>
                    <div class="prelative">
                      <v-text-field
                        outlined
                        :value="name" @input="updateName"
                        label="Vor- und Nachname*"
                        :rules="nameRules"
                        placeholder="Vorname Nachname"
                        illed hide-details
                        required
                        @focus="hideToolbar"
                        @blur="unhideToolbar"
                      ></v-text-field>
                      <div v-if="name" class="absClear">
                        <v-icon class="myBlack" @click.passive.stop="name=''"
                        >mdi-close
                        </v-icon>
                      </div>
                    </div>

                    <div class="prelative">
                      <v-text-field
                        outlined
                        :value="email" @input="updateEmail"
                        :rules="emailRules"
                        ref="email"
                        label="E-Mail (vorgeschrieben für Online-Zahlung)"
                        illed hide-details
                        required
                        @focus="hideToolbar"
                        @blur="unhideToolbar"
                      ></v-text-field>
                      <div v-if="email" class="absClear">
                        <v-icon class="myBlack" @click.passive.stop="email=''"
                        >mdi-close
                        </v-icon>
                      </div>
                    </div>

                    <template v-if="$store.state.enableOrderNote">
                      <div class="prelative">
                        <v-text-field
                          outlined
                          ref="phone"
                          @keydown="phoneKeydown($event)"
                          :value="phone" @input="updatePhone"
                          :rules="phoneRules"
                          :label="selfServiceEnabled ? 'Mobilnummer*' : 'Mobilnummer (optional)'"
                          placeholder=""
                          illed
                        ></v-text-field>
                        <div v-if="phone" class="absClear">
                          <v-icon class="myBlack" @click.passive.stop="phone=''"
                          >mdi-close
                          </v-icon>
                        </div>
                      </div>

                      <v-text-field
                        outlined
                        hide-details
                        ref="note"
                        v-model="note"
                        label="Notiz"
                        @keyup.enter="finishStep1"
                        clearable
                        illed
                      ></v-text-field>
                    </template>
                    <template v-else>
                      <div class="prelative">
                        <v-text-field
                          outlined
                          ref="phone"
                          @keydown="phoneKeydown($event)"
                          v-model="phone"
                          :rules="phoneRules"
                          :label="selfServiceEnabled ? 'Mobilnummer*' : 'Mobilnummer (optional)'"
                          placeholder="Für evtl. Rückfragen"
                          illed
                          @keyup.enter="finishStep1"
                        ></v-text-field>
                        <div v-if="phone" class="absClear">
                          <v-icon class="myBlack" @click.passive.stop="phone=''"
                          >mdi-close
                          </v-icon>
                        </div>
                      </div>
                    </template>
                  </template>


                  <!--                                label="Mobilnummer* (ohne Ländervorwahl)"-->
                  <!--                            <pre v-if="$refs.phone">-->
                  <!--      hasError: {{$refs.phone.hasError}}-->
                  <!--      valid: {{$refs.phone.valid}}-->
                  <!--    </pre>-->
                  <!--                <p class="hinweis">Hinweis: Deine Daten werden nur zum Zweck dieser Bestellung-->
                  <!--                  verwendet und nicht-->
                  <!--                  &lt;!&ndash;                                zu keinem Zeitpunkt &ndash;&gt;-->
                  <!--                  an Dritte weitergegeben. Deine Mobilnummer benötigen wir für evtl.-->
                  <!--                  Rückfragen.</p>-->

                  <!--                                <h4 class="mt-7 mb-4">Rechnungsadresse</h4>-->
                  <!--                                &lt;!&ndash;                            <form>&ndash;&gt;-->
                  <!--                                <v-text-field-->
                  <!--                                        v-model="name"-->
                  <!--                                        label="Vor- und Nachname"-->
                  <!--                                        illed hide-details-->
                  <!--                                        v-if="invoiceAddress.company.length === 0"-->
                  <!--                                ></v-text-field>-->
                  <!--                                <v-text-field-->
                  <!--                                        v-model="invoiceAddress.company"-->
                  <!--                                        label="Firma (optional)"-->
                  <!--                                        illed hide-details-->
                  <!--                                        required-->
                  <!--                                        @focus="hideToolbar"-->
                  <!--                                        @blur="unhideToolbar"-->
                  <!--                                ></v-text-field>-->
                  <!--                                <v-text-field-->
                  <!--                                        v-model="invoiceAddress.street"-->
                  <!--                                        label="Straße und Hausnummer*"-->
                  <!--                                        illed hide-details-->
                  <!--                                        required-->
                  <!--                                        @focus="hideToolbar"-->
                  <!--                                        @blur="unhideToolbar"-->
                  <!--                                ></v-text-field>-->

                  <!--                                <table class="maxw myTable">-->
                  <!--                                    <tr>-->
                  <!--                                        <td>-->
                  <!--                                            <v-text-field-->
                  <!--                                                    v-model="invoiceAddress.plz"-->
                  <!--                                                    label="PLZ*"-->
                  <!--                                                    illed hide-details-->
                  <!--                                                    required-->
                  <!--                                                    @focus="hideToolbar"-->
                  <!--                                                    @blur="unhideToolbar"-->
                  <!--                                            ></v-text-field>-->
                  <!--                                        </td>-->
                  <!--                                        <td>-->
                  <!--                                            <v-text-field-->
                  <!--                                                    v-model="invoiceAddress.city"-->
                  <!--                                                    label="Stadt*"-->
                  <!--                                                    illed hide-details-->
                  <!--                                                    required-->
                  <!--                                                    @focus="hideToolbar"-->
                  <!--                                                    @blur="unhideToolbar"-->
                  <!--                                            ></v-text-field>-->
                  <!--                                        </td>-->
                  <!--                                    </tr>-->
                  <!--                                </table>-->
                  <div class="switch-wrapper">
                    <v-switch @change="toggleInvoiceAddress" label="Firmenrechnung" color="success"></v-switch>
                  </div>
                  <!-- <toggle-button @change="toggleVisibility" :class="{ active: isVisible }" :labels="{checked: 'ON', unchecked: 'OFF'}" /> -->

                  <div v-if="isInvoiceAddressVisible" class="content">
                    <h4 class="mt-7 mb-4">Rechnungsadresse</h4>
                    <v-text-field outlined
                                  :rules="companyRules"
                                  v-model="invoiceAddress.company" label="Firma*" illed hide-details required
                                  @focus="hideToolbar" @blur="unhideToolbar"></v-text-field>
                    <v-text-field outlined
                                  :rules="streetRules"
                                  v-model="invoiceAddress.street" label="Straße und Hausnummer*" illed
                                  hide-details
                                  required @focus="hideToolbar" @blur="unhideToolbar"></v-text-field>
                    <table class="maxw myTable">
                      <tr>
                        <td>
                          <v-text-field outlined
                                        :rules="plzRules"
                                        v-model="invoiceAddress.plz" label="PLZ*" illed hide-details required
                                        @focus="hideToolbar" @blur="unhideToolbar"></v-text-field>
                        </td>
                        <td>
                          <v-text-field outlined
                                        :rules="cityRules"
                                        v-model="invoiceAddress.city" label="Stadt*" illed hide-details required
                                        @focus="hideToolbar" @blur="unhideToolbar"></v-text-field>
                        </td>
                      </tr>
                    </table>
                  </div>


                  <div class="mehrwegOption align-start mt-2" v-if="$store.state.enableMehrwegOption">
                    <div
                      @click.passive="selectMehrwegOption"
                      class="option pointer" :class="{selected: mehrwegOption.aaaSelected}">
                      <v-icon v-if="mehrwegOption.aaaSelected">
                        mdi-check-box-outline
                      </v-icon>
                      <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                    </div>

                    <div style="padding-left: 1.9%" class="fasterGrow">
                      Ich möchte meine Bestellung in einer Mehrweg-Verpackung
                      der Firma {{ $store.state.mehrwegCompanyName }} erhalten.
                      <div class="pt-1">
                        <strong>Hinweis: </strong> Dafür musst du bereits registrietes Mitglied sein
                      </div>
                    </div>
                  </div>
                </v-form>
              </div>


              <div class="mt-2" v-if="!$store.getters.isKiosk">
                <div class="error--text mt-2 mb-4" v-if="step1Error && initialTry">{{ step1Error }}</div>
                <v-btn class="primepulsing btn-df weiter" @click.native.passive="finishStep1">
                  Weiter
                </v-btn>
                <!--                            :disabled="!step1Ok"-->
              </div>
              <!--                    <v-btn class="mt-3"-->
              <!--                           @click.native.passive="currentStep = 1">-->
              <!--                        Zurück-->
              <!--                    </v-btn>-->
            </div>


            <!--                <v-btn color="primary" @click="currentStep = 2">Continue</v-btn>-->
          </v-stepper-content>


          <template v-if="!$store.getters.isKiosk">
            <v-stepper-step :complete="currentStep > 2" step="2">
              <div class="nice-title titleFont">Abholzeit: {{ selectedAbholDatum.value }}
                <span v-if="userSelectedHeute && timesToday.length > 0 && time">, {{ time.value }} Uhr</span><span
                  v-if="!userSelectedHeute && timesTomorrow.length > 0 && time">, {{ time.value }} Uhr</span>
              </div>
            </v-stepper-step>
            <v-stepper-content id="abholung" step="2">
              <v-layout row wrap class="pt-4">
                <v-flex xs12 md3>
                  <div class="d-flex flex-nowrap flex-md-wrap">
                    <h4 class="flex-shrink-0 flex-grow-0 flex-md-grow-1 mr-2 breakTitle text-no-wrap"
                    >Datum:</h4>
                    <v-select hide-details :items="abholDatumArray" item-text="value" v-model="selectedAbholDatum"
                              return-object illed></v-select>
                  </div>
                </v-flex>
                <v-flex xs12 md1 class="hidden-sm-and-down">
                </v-flex>
                <v-flex xs12 md4>

                  <div class="d-flex flex-nowrap flex-md-wrap">
                    <h4 class="flex-shrink-0 flex-grow-0 flex-md-grow-1 mr-2 breakTitle text-no-wrap"
                    >Abholzeit:</h4>
                    <v-select v-if="selectedAbholDatum.value === 'Heute'" hide-details :items="timesToday"
                              item-text="display" v-model="time" :class="{selectBlinker: !(time && time.value)}"
                              return-object illed
                              placeholder="Uhrzeit auswählen"></v-select>
                    <v-select v-if="selectedAbholDatum.value === 'Morgen'" hide-details :items="timesTomorrow"
                              item-text="display" v-model="time" :class="{selectBlinker: !(time && time.value)}"
                              return-object illed
                              placeholder="Uhrzeit auswählen"></v-select>
                  </div>
                </v-flex>
              </v-layout>


              <h4 class="mt-4 mb-1">Abholadresse:</h4>
              <div>
                <!--                                            <h4 class="d-inline-block">Anschrift:  </h4>-->
                <!--                        {{$store.state.brandName}}<br>-->
                {{ abholadresse }}
                <!--                        Sudhaus<br>-->
                <!--                        Dieplohstraße 12<br>-->
                <!--                        59581 Warstein<br>-->
              </div>

              <!--                    <v-btn-toggle-->
              <!--                            v-model="userSelectedHeute"-->
              <!--                            tile-->
              <!--                            color="#B0916A"-->
              <!--                            group-->
              <!--                    >-->
              <!--                        <v-btn value="Heute">-->
              <!--                            Heute-->
              <!--                        </v-btn>-->

              <!--                        <v-btn value="Morgen">-->
              <!--                            Morgen-->
              <!--                        </v-btn>-->
              <!--                    </v-btn-toggle>-->


              <div class="mt-4 weiterAndBack">
                <v-btn class="primepulsing btn-df weiter"
                       @click.native.passive="finishStep2">
                  Weiter
                </v-btn>
                <v-btn class="bback" @click.native.passive="currentStep = 1">
                  Zurück
                </v-btn>
              </div>
            </v-stepper-content>

            <!--                CAPTCHA STEP-->
            <v-stepper-step :complete="currentStep > 3" step="3">
              <div class="nice-title small">Bestellung bestätigen
              </div>
            </v-stepper-step>
            <v-stepper-content id="confirmation" step="3">


              <!--                    <h4 class="mt-1 mb-1">Zahlung bei Abholung:</h4>-->
              <div class="mt-4" v-if="!$store.getters.isKiosk">
                <!--                        <div>Der Bestellbutton wird erst angezeigt, wenn die App fertiggestellt ist</div>-->
                <div>
                  <v-btn class="orderBtn wallet-width text-none rounded100"
                         color="green"
                         dark
                         @click.native.passive="doOrder">
                    <!--<v-icon left class="">mdi-lock-check</v-icon>-->
                    Zahlungspflichtig bestellen
                    <!--                                    v-if="captchaInput.length===4"-->
                  </v-btn>
                </div>
                <orderconsent></orderconsent>
                <!--                        <v-btn class="primepulsing btn-df weiter"-->
                <!--                               color="primary"-->
                <!--                               :disabled="!(time && time.value)"-->
                <!--                               rounded-->
                <!--                               @click.native.passive="finishStep2">-->
                <!--                            Weiter-->
                <!--                        </v-btn>-->
              </div>
              <div class="mt-3">Die Bezahlung erfolgt bei Abholung.</div>
              <div>{{ displayPaymentMethods() }}</div>
              <v-btn class="mt-4 btn-df weiter grayBtn" rounded
                     @click.native.passive="currentStep = 2">
                Zurück
              </v-btn>
            </v-stepper-content>

          </template>


        </v-stepper>
      </div>

      <div class="mt-4 text-center" v-if="$store.getters.isKiosk">
        <div>
          <v-btn class="mt-3 orderBtn wallet-width text-none rounded100"
                 color="green"
                 dark
                 @click.native.passive="doOrder">
            Bestätige deine Bestellung
          </v-btn>
        </div>
      </div>


    </v-container>

    <!--        <h3>TESt time = {{time}}</h3>-->

    <template v-if="!$store.getters.isKiosk">
      <ssl-seal></ssl-seal>
    </template>

    <!--        <h2>payment request button</h2>-->

    <!--        <div class="text-center">-->
    <!--            <div class="inlinecenter">-->
    <!--                <div style="width: 250px;">-->
    <!--                    <div id="payment-request-button" style="display: none; margin-top:25px">-->
    <!--                        &lt;!&ndash; A Stripe Element will be inserted here. &ndash;&gt;-->
    <!--                    </div>-->
    <!--                </div>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <h2>Credit card</h2>-->

    <!--        <div>-->
    <!--            <main class="payment">-->
    <!--                <section class="container-lg">-->
    <!--                    <div class="cell example example1">-->
    <!--                        <div class="verifyOverlay">-->
    <!--                            <img ng-src="../v/images/loader.gif">-->
    <!--                        </div>-->
    <!--                        <h3 class="text-center" style="margin: 0 0 25px 0;" translate="checkout.oayWithCC"></h3>-->
    <!--                        <form>-->
    <!--                            <fieldset>-->
    <!--                                <div class="row">-->
    <!--                                    <table class="maxw">-->
    <!--                                        <tr>-->
    <!--                                            <td style="width: 10%;"><label for="example1-name" data-tid="elements_examples.form.name_label"-->
    <!--                                                                           translate="checkout.holder"></label>-->
    <!--                                            </td>-->
    <!--                                            <td style="padding-left: 20px; padding-right: 25px;">-->
    <!--                                                <input id="example1-name"-->
    <!--                                                       data-tid="elements_examples.form.name_placeholder"-->
    <!--                                                       type="text"-->
    <!--                                                       placeholder="Jane Doe"-->
    <!--                                                       required="" autocomplete="name">-->
    <!--                                            </td>-->
    <!--                                        </tr>-->
    <!--                                    </table>-->
    <!--                                </div>-->
    <!--                                &lt;!&ndash;<div class="row">&ndash;&gt;-->
    <!--                                &lt;!&ndash;<label for="example1-email" data-tid="elements_examples.form.email_label">Email</label>&ndash;&gt;-->
    <!--                                &lt;!&ndash;<input id="example1-email" type="email" required="" ng-model="checkout.email">&ndash;&gt;-->
    <!--                                &lt;!&ndash;</div>&ndash;&gt;-->
    <!--                                &lt;!&ndash;<div class="row">&ndash;&gt;-->
    <!--                                &lt;!&ndash;<label for="example1-phone" data-tid="elements_examples.form.phone_label">Phone</label>&ndash;&gt;-->
    <!--                                &lt;!&ndash;<input id="example1-phone" data-tid="elements_examples.form.phone_placeholder" type="tel"&ndash;&gt;-->
    <!--                                &lt;!&ndash;placeholder="(941) 555-0123" required="" autocomplete="tel">&ndash;&gt;-->
    <!--                                &lt;!&ndash;</div>&ndash;&gt;-->
    <!--                            </fieldset>-->
    <!--                            <fieldset>-->
    <!--                                <div class="row">-->
    <!--                                    <div id="example1-card"></div>-->
    <!--                                </div>-->
    <!--                            </fieldset>-->
    <!--                            <button type="submit" data-tid="elements_examples.form.pay_button"><span-->
    <!--                                    translate="checkout.pay"></span>-->
    <!--                                {{checkout.amount | price}}-->
    <!--                            </button>-->
    <!--                            <div class="error" role="alert">-->
    <!--                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">-->
    <!--                                    <path class="base" fill="#000"-->
    <!--                                          d="M8.5,17 C3.80557963,17 0,13.1944204 0,8.5 C0,3.80557963 3.80557963,0 8.5,0 C13.1944204,0 17,3.80557963 17,8.5 C17,13.1944204 13.1944204,17 8.5,17 Z"></path>-->
    <!--                                    <path class="glyph" fill="#FFF"-->
    <!--                                          d="M8.5,7.29791847 L6.12604076,4.92395924 C5.79409512,4.59201359 5.25590488,4.59201359 4.92395924,4.92395924 C4.59201359,5.25590488 4.59201359,5.79409512 4.92395924,6.12604076 L7.29791847,8.5 L4.92395924,10.8739592 C4.59201359,11.2059049 4.59201359,11.7440951 4.92395924,12.0760408 C5.25590488,12.4079864 5.79409512,12.4079864 6.12604076,12.0760408 L8.5,9.70208153 L10.8739592,12.0760408 C11.2059049,12.4079864 11.7440951,12.4079864 12.0760408,12.0760408 C12.4079864,11.7440951 12.4079864,11.2059049 12.0760408,10.8739592 L9.70208153,8.5 L12.0760408,6.12604076 C12.4079864,5.79409512 12.4079864,5.25590488 12.0760408,4.92395924 C11.7440951,4.59201359 11.2059049,4.59201359 10.8739592,4.92395924 L8.5,7.29791847 L8.5,7.29791847 Z"></path>-->
    <!--                                </svg>-->
    <!--                                <span class="message"></span></div>-->
    <!--                        </form>-->


    <!--                    </div>&lt;!&ndash;eof cell&ndash;&gt;-->
    <!--                </section>-->
    <!--            </main>-->
    <!--        </div>-->


    <!--        <input id="cardholder-name" type="text">-->
    <!--        &lt;!&ndash; placeholder for Elements &ndash;&gt;-->
    <!--        <div id="card-element"></div>-->
    <!--        <button id="card-button">-->
    <!--            Submit Payment-->
    <!--        </button>-->

    <div class="text-center">
      <!--      <v-btn style="margin-top: 25px" class="text-none btn-df"-->
      <!--             @click.native.passive="gotoSummary">-->
      <!--        Zurück zum Korb-->
      <!--      </v-btn>-->
      <div class="spacer-25"></div>
      <v-btn style="margin-top: 25px" class="text-none btn-mini" @click="cancelOrder">
        Bestellung abbrechen
      </v-btn>
    </div>

    <!--        <times-info-dialog :dialog="timesInfoDialog" @close="timesInfoDialog = false"></times-info-dialog>-->

    <div class="spacer-25"></div>

    <!--        <qsignal class="hide-md"></qsignal>-->

    <div v-if="showKeyboard" class="fixedVirtualKeyboard">
      <div class="superCenter">
        <VirtualKeyboard
          :label="keyboardLabel"
          @enter="keyboardEnter"
          @close="showKeyboard = false"
        ></VirtualKeyboard>
      </div>
    </div>

  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as bootstrap from '../vendor/bootstrap';
import * as xhr from '../api/xhr.js'
import * as iframe from "../iframe/iframe";
import * as util from '../vendor/util'
import {clearTheInterval, cloneMe, generatePickupDate, getUhrzeit, isEmptyObject, isPlzOk} from '../vendor/util'
// import* as plausi from '../vendor/plausi'
import * as qconst from '../vendor/qconstants';
import {getDisplayPaymentMethods, kioskResetTimeoutAfterOrder} from '../vendor/qconstants';

import * as firebaseUtil from '@/firebase/firebaseUtil'
// TODO activate for online
// import* as paypalUtil from '../paypal/paypalUtil'
import Orderconsent from "../components/orderconsent";

// import Qsignal from "../components/qsignal";
import SslSeal from "../components/sslSeal";
import {googlePayMerchantId} from "@/goodpay/goodpayUtil";
import {getName2Error, isEmailOk, isIos, isMobileOk, roundToTwo} from "@/vendor/util";
import {setGlobalKeyValue} from "@/util/globalState";
import {getErrorDetails} from "@/util/globalErrorHandler";
import VirtualKeyboard from "../kiosk/VirtualKeyboard.vue";
// import* as breakpoints from '../vendor/breakpoints'
// import TimesInfoDialog from "../dialogs/TimesInfoDialog";


export default {
  components: {VirtualKeyboard, Orderconsent, SslSeal},

  data() {
    return {
      showKeyboard: false,
      keyboardLabel: '',
      mehrwegOption: {
        aaaSelected: false,
      },
      valid: true,
      showForm: true,
      initialTry: false,
      clientId: '',
      fastUnload: false,
      updateInterval: null,
      isInvoiceAddressVisible: false,

      hasFd: true,

      //captcha
      captchaInput: '',
      // numberRule: v  => {
      //     if (!v.trim()) return true;
      //     if (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999) return true;
      //     return 'Number has to be between 0 and 9999';
      // },

      //abholung öffnungszeiten
      abholDatumArray: [
        {value: 'Heute'},
        {value: 'Morgen'}
      ],
      selectedAbholDatum: {value: 'Heute'},//default
      time: null, //{value:'06:45', utc:...}//produces a string i.e. 06:45
      timesToday: [
        //{
        //     value: h + ':' + minute,
        // display: 'ca. ' + h + ':' + minute + ' Uhr',
        // utc: utcValue.getTime()
        // }
      ],
      timesTomorrow: [
        //{
        //     value: h + ':' + minute,
        // display: 'ca. ' + h + ':' + minute + ' Uhr',
        // utc: utcValue.getTime()
        // }
      ],

      //Formulardaten
      name: '',
      nameRules: [
        v => store.getters.isKiosk || (!v && !this.selfServiceEnabled) || !util.getName1Error(v) || util.getName1Error(v),
        // v => !getName2Error(v) || 'Bitte vollständigen Namen eingeben',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-Mail ist erforderlich',
        v => isEmailOk(v) || 'Ungültige E-Mail',
      ],
      phone: '',
      phoneRules: [
        // v => !!v || 'Die Mobilnummer wird benötigt',
        // v => /^(?=.*\d)[\d ]+$/.test(v) || 'Dieses Feld darf nur Nummern oder Leerzeichen enthalten',
        v => (!v && !this.selfServiceEnabled) || isMobileOk(v) || 'Die Mobilnummer ist zu kurz'
      ],
      companyRules: [
        v => (v && v.length > 1) || 'Firmenname ist erforderlich',
      ],
      streetRules: [
        v => (v && !getName2Error(v)) || 'Straße und Hausnummer sind erforderlich',
      ],
      plzRules: [
        v => (v && v.length > 1) || 'Postleitzahl ist erforderlich',
      ],
      cityRules: [
        v => (v && v.length > 1) || 'Stadt ist erforderlich',
      ],
      // vorname: '',
      // nachname: '',
      sameAsInvoiceAddress: true,
      invoiceAddress: {
        company: '',
        street: '',
        plz: '',
        city: '',
      },

      step1Error: '',

      note: '',


      // autoModel: null,
      // {
      //     displayName: '345567 Straße, Maxdorf',
      //         obj: storeObject
      // }

      // selectedStore: {
      //     // plz:'',
      //     // strasse:'',
      //     //   openingHours:
      // },
      // stores: [],
      consent: false,

      showBar: false,
      //TODO activate for online
      showStripe: false,
      showPaypal: false,

      hasPR: false,
      wait: false,
      total: 0,

      // earlyPaymentIntentId: '',
      // earlyClientSecret: '',

      // deliveryFee: 0,
      // fee: 0,
      // minOrderAmount: 0,

      currentStep: 1,
      usecase: qconst.usecase$takeAway,//initial value 'delivery',
      // daySelected: 'asap',

      // time: null, //{value:'06:45'}//produces a string i.e. 06:45
      // times: [
      //     //{ value : '06:45'}
      // ],

      // internalDaySelected: '1',

      psp: 'beiAbholung', //none, bar, credit, paypal

      // consentA: false,
      // consentB: false,

      order: {},

      unloadTargetTime: 0,

      //Stripe
      stripePreAuth: {},
      usingPaymentRequest: false,
      orderId: '',
      paymentIntentId: '',
      clientSecret: '',
      paymentRequestCreated: false,
      paymentRequestObject: {},
      paymentRequesttotal: 0,

      prButton: null,

      //paypal
      paypalOrderId: null,
      // paypalPreAuth: {},

      // paymentIntentAmount: -1,
      paymentIntentStatus: '',
      orderNumber: '',
      uniqueOrderId: '',

      //only calculated:
      pickupDate: {},
      // displayPickupDate: '',

      // timesInfoDialog: false,
      timesInfoDialog: false,
    }
  },

  watch: {
    selectedAbholDatum(newVal) {
      this.time = null;
    },
    // currentStep(newValue){
    //     if(newValue === 2){
    //
    //     }
    // }
    // sameAsInvoiceAddress(newValue) {
    //     if (this.step1Ok) {
    //         this.step1Error = '';
    //     }
    // },

    // autoModel(newValue) {
    //     if (newValue.obj) {
    //         this.$ls.set('selectedStore', JSON.stringify(newValue.obj));
    //         store.getters.selectedStore = newValue.obj;
    //         store.commit('selectedStore', util.cloneMe(newValue.ob));
    //         // this.updateMinOrderAmount();
    //     }
    // },

    // daySelected(newValue) {
    //     if (newValue === '1') {
    //         this.preselectDay1();
    //     } else if (newValue === '2') {
    //         this.preselectDay2();
    //     } else {
    //         this.time = '';
    //     }
    // },

    // consentB(newValue) {
    //     if (newValue && this.consentA) {
    //         this.currentStep = 4;
    //     }
    // },
    // consentA(newValue) {
    //     if (newValue && this.consentB) {
    //         this.currentStep = 4;
    //     }
    // },


    time(newValue) {
      if (newValue && newValue.utc) {
        this.$ls.set('selectedTime', newValue);
        //         store.commit('selectedTime', util.cloneMe(newValue));
      }
    },

  },

  computed: {
    mindestbestellwert() {
      const v = store.getters.appconfig.takeAway.minOrderAmount;
      return this.$options.filters.priceTotal(v);
    },
    asGuest() {
      return store.getters.loggedIn === false;
    },

    selfServiceEnabled() {
      return this.$store.getters.selfServiceEnabled;
    },

    abholadresse() {
      return '' + store.state.staticDisplayAbholung;
      // if (store.getters.selectedStore.strasse) {
      //     let strasse = store.getters.selectedStore.strasse;
      //     let plzOrt = store.getters.selectedStore.plz + ' ' + store.getters.selectedStore.ort;
      //     return strasse + ', ' + plzOrt;
      // }
      // return '';
    },
    // displayTomorrow() {
    //     let tomorrow = util.addDays(util.getCurrentRemoteTime(), 1);
    //     return this.$options.filters.weekDayMonth(tomorrow.getTime(), true);
    //
    //     // let d = tomorrow.toLocaleString();
    //     // return d.substring(0, d.indexOf(','));
    // },

    userSelectedHeute() {
      return this.selectedAbholDatum.value === 'Heute';
    },

    step1Ok() {
      if (store.getters.isKiosk) {
        return true;
      }

      let name2Error = util.getName2Error(this.name);
      if (name2Error) {
        this.step1Error = name2Error
        return false;
      }
      this.email = util.removeSpaces(this.email);
      if (!util.isEmailOk(this.email)) {
        this.step1Error = 'Die E-Mail Addresse ist ungültig';
        return false;
      }


      // try {
      //   if (!isMobileOk(this.phone) || !(this.$refs.phone.valid && !this.$refs.phone.hasError)) {
      //     this.step1Error = 'Die eingegebene Mobilnummer ist ungültig';
      //     return false;
      //   }
      // } catch (e) {
      //   console.log('FIXME phone error: ' + e.message);
      //   return false;
      // }

      // //InvoiceAddress

      if (this.isInvoiceAddressVisible) {
        //company
        if (!this.invoiceAddress.company || this.invoiceAddress.company.length < 4) {
          this.step1Error = 'Das Unternehmen ist erforderlich';
          return false;
        }
        //street
        if (this.invoiceAddress.street.length < 4) {
          this.step1Error = 'Die Straße ist erforderlich';
          return false;
        }

        if (
          this.invoiceAddress?.street?.length > 0 &&
          !/\b\d+[a-zA-Z]?\b/.test(this.invoiceAddress.street)
        ) {
          this.step1Error = 'Die Hausnummer fehlt';
          return false;
        }
        // if (this.invoiceAddress.street.length > 0 && (/\d/.test(this.invoiceAddress.street) === false)) {
        //   this.step1Error = 'Die Hausnummer fehlt';
        //   return false;
        // }
        //validate plz
        if (!this.invoiceAddress.plz || this.invoiceAddress.plz.length == 0) {
          this.step1Error = 'Die Postleitzahl ist erforderlich';
          return false;
        }
        let plz = util.removeSpaces(this.invoiceAddress.plz);
        if (!!isPlzOk(plz) === false) {
          this.step1Error = 'Die Postleitzahl muss eine Nummer sein';
          return false;
        }
        if (plz.length < 4) {
          this.step1Error = 'Die Postleitzahl ist zu kurz';
          return false;
        }
        //city
        if (this.invoiceAddress.city.length < 3) {
          this.step1Error = 'Der Ort ist erforderlich';
          return false;
        }
      }


      //

      // if (!this.sameAsInvoiceAddress) {
      //     //deliveryAddress
      //     if (this.deliveryAddress.street.length < 4) {
      //         this.step1Error = 'Die Straße ist erforderlich';
      //         return false;
      //     }
      //
      //     if (this.deliveryAddress.street.length > 0 && (/\d/.test(this.deliveryAddress.street) === false)) {
      //         this.step1Error = 'Die Hausnummer fehlt';
      //         return false;
      //     }
      //
      //     //validate plz
      //     if (this.deliveryAddress.plz.length < 4) {
      //         this.step1Error = 'Die Postleitzahl ist erforderlich';
      //         return false;
      //     }
      //     let plz = this.deliveryAddress.plz.trim();
      //     if (isPlzOk(plz) === false) {
      //         this.step1Error = 'Die Postleitzahl muss eine Nummer sein';
      //         return false;
      //     }
      //     if (plz.length < 4) {
      //         this.step1Error = 'Die Postleitzahl ist zu kurz';
      //         return false;
      //     }
      //
      //     //city
      //     if (this.deliveryAddress.city.length < 3) {
      //         this.step1Error = 'Der Ort ist erforderlich';
      //         return false;
      //     }
      // }
      this.step1Error = '';
      return true;
    },

    paymentMethods() {
      // let pms = store.getters.paymentMethods;
      // // if (!this.selectedAliasId && pms.length > 0) {
      // //   this.preselectCreditCard();
      // // }
      // return pms;
    },

    // autocompleteStores() {
    //     let allstores = util.cloneMe(store.getters.stores);
    //     let model = [];
    //     for (let store of allstores) {
    //         model.push(
    //             {
    //                 displayName: store.strasse + ', ' + store.plz + ' ' + store.ort,
    //                 obj: store
    //             });
    //     }
    //     return model;
    // },

    // displayLieferwunsch() {
    //     if (this.daySelected === 'asap') {
    //         return 'So schnell wie möglich';
    //     } else if (this.daySelected === '1') {
    //         return 'Vorbestellung Heute';
    //     } else if (this.daySelected === '2') {
    //         return 'Vorbestellung Morgen';
    //     }
    //     return '';
    // }
  },

  beforeMount() {
    if (!this.checkEnter()) {
      return;
    }
    let theTotal = this.$ls.get('theTotal');
    if (theTotal) {
      this.paymentRequestTotal = theTotal;
    }
    this.updateTotal();

    let itemsString = JSON.stringify(store.getters.cartItems);
    try {
      let itemsHash = new Hashes.SHA256().hex(itemsString);
      if (itemsHash === this.$ls.get('lastItemsHash')) {
        console.log('use the same clientId');
        // this.$ls.set('clientId', util.generateClientId());
      } else {
        console.log('generate a new clientId');
        this.$ls.set('lastItemsHash', itemsHash);
        this.$ls.set('clientId', util.generateClientId());
      }
    } catch (e) {
    }
  },

  created() {
    ebus.$on('appconfigLoaded', () => {
      // if (this.timesToday.length === 0) {
      this.init();
      // }
    });

    ebus.$on('cb-postToWindowskiosk', (resp) => {
      if (resp && !isEmptyObject(resp)) {
        const responseAction = '' + resp.action;
        delete resp.action;

        if (responseAction === 'checkTerminalServiceActive') {
          if (!(resp.ok && resp.configSetupCompleted)) {
            ebus.$emit('showInfo', {
              title: 'WARNING: The device setup is incomplete. Please contact the administrator',
            });
            this.$router.replace({name: 'Home'});
          }
        }
      }
    });

  },

  mounted() {
    this.checkTerminalOrFail();
    this.preInit();

    if (this.asGuest && this.$store.getters.enableStempel) {
      ebus.$emit('toast', 'Bitte melde dich an, um Punkte für deine Stempelkarte zu sammeln');
    }

    ebus.$emit('loadAppconfig');
    store.state.hideScroll = true;
  },

  destroyed() {
    this.safeUnload();

    util.clearEvents([
      'appconfigLoaded',
      'cb-postToWindowskiosk',
    ]);

    store.state.hideScroll = false;
    // this.earlyClientSecret = '';
    this.clientSecret = '';
    this.order = {};
    this.usingPaymentRequest = false;
    this.paymentIntentId = '';
    // this.creditPreAuth = {};
    // this.paypalPreAuth = {};
    // document.getElementById('paypal-button-container').innerHTML = '';
    this.currentStep = 1;

    // this.paymentRequestCreated = false;


    util.clearTheInterval(this.updateInterval);

  },

  methods: {
    keyboardEnter(text) {
      if (this.keyboardLabel === 'Dein Name') {
        this.name = text;
      } else if (this.keyboardLabel === 'Hinweise zur Bestellung') {
        this.note = text;
      }
      this.showKeyboard = false;
    },
    nameFocus() {
      if (store.getters.isKiosk) {
        console.log('nameFocus');
        this.keyboardLabel = 'Dein Name';
        this.showKeyboard = true;
      }
      this.hideToolbar();
    },
    hinweisFocus() {
      if (store.getters.isKiosk) {
        console.log('nameFocus');
        this.keyboardLabel = 'Hinweise zur Bestellung';
        this.showKeyboard = true;
      }
      this.hideToolbar();
    },

    cancelOrder() {
      window.history.back();
    },

    displayPaymentMethods() {
      return getDisplayPaymentMethods(true);
    },

    checkTerminalOrFail() {
      ebus.$emit('postToWindowskiosk', {
        action: 'checkTerminalServiceActive',
        cb: 'cb-postToWindowskiosk'
      });
    },

    refreshForm() {
      if (isIos()) {
        this.showForm = false;
        setTimeout(() => {
          this.showForm = true;
        }, 400);
      }
    },
    resetValidation() {
      this.$nextTick(() => {
        this.$refs.orderDataForm.resetValidation();
        this.refreshForm()//Bugfix for https://github.com/vuetifyjs/vuetify/issues/11942
      });
    },
    selectMehrwegOption() {
      let option = this.mehrwegOption;
      if (option.aaaSelected) {
        option.aaaSelected = false;
      } else {
        option.aaaSelected = true;
      }
    },
    validate() {
      try {
        return this.$refs.orderDataForm.validate()
      } catch (e) {
        return false;
      }
    },
    updateName(v) {
      this.$nextTick(() => {
        this.name = v;
      });
    },
    updateEmail(v) {
      this.$nextTick(() => {
        this.email = v;
      });
    },
    updatePhone(v) {
      this.$nextTick(() => {
        this.phone = v;
      });
    },
    setFromCheckout() {
      setGlobalKeyValue('fromCheckout', true)
      this.fromCheckout = true;
    },
    removeFromCheckout() {
      removeGlobalKey('fromCheckout');
      this.fromCheckout = false;
    },
    // async onApplePaymentButtonClicked() {
    //   if (this.isMissingAgbs()) {
    //     return;
    //   }
    //
    //   let self = this;
    //   this.safeUnload(30);
    //
    //   let label = "Bestellung bei " + store.state.brandName;
    //   let amount = (0 + this.total);
    //
    //   // if (false) {
    //   if (window.PaymentRequest) {
    //     const data = await createApplePayPaymentRequest(
    //       // cartData.products.map((item) => {
    //       //   return {label: item.name, amount: item.amount};
    //       // }),
    //       label,
    //       amount,
    //     )
    //       .show()
    //       .then(function (response) {
    //         console.log('applepay response from paymentRequest: ' + JSON.stringify(response));
    //         // Dismiss payment dialog.
    //         response.complete('success');
    //         return response
    //       })
    //       .catch((err) => {
    //         self.stopLoading();
    //         let e = 'Code TAPR'; //takeaway applepay payment request

// let errorDetails = getErrorDetails(err);
//             if (errorDetails) {
//               e += ' - ' + errorDetails;
//             }
    //takeaway applepay payment request
    //         self.notifyError(e);
    //         self.stopLoading();
    //         ebus.$emit('throwError', getErrorDetails(err, 'TODOTHROW',  ' error=' +e));
    //         // alert('show() error! ' + err.name + ' error: ' + err.message);
    //       });
    //     let tokenJson = data.details.token.paymentData;
    //     console.log('applepay tokenJson from paymentRequest: ' + JSON.stringify(tokenJson));
    //     self.handleApplePaymentToken(self, tokenJson);
    //     return true;
    //   } else {
    //     const data = await performApplePayPayment(
    //       // cartData.products.map((item) => {
    //       //   return {label: item.name, amount: item.amount};
    //       // }),
    //       label,
    //       amount,
    //     )
    //       .then(function (response) {
    //         console.log('applepay response from ApplePayJs: ' + JSON.stringify(response));
    //         return response
    //       })
    //       .catch((err) => {
    //         self.stopLoading();
    //         let e = 'Code TAJS'; //takeaway applepay apple Js
    //         self.notifyError(e);
    //         self.stopLoading();
    //         ebus.$emit('throwError', getErrorDetails(err, 'TODOTHROW',  ' error=' +e));
    //         // alert('show() error! ' + err.name + ' error: ' + err.message);
    //       });
    //     let tokenJson = data.token.paymentData;
    //     console.log('applepay payment token from ApplePayJs: ' + JSON.stringify(tokenJson));
    //     self.handleApplePaymentToken(self, tokenJson);
    //     return true;
    //   }
    //
    //
    //   // performPayment(
    //   //   currency_code,
    //   //   cartData.products.map((item) => {
    //   //     return {label: item.name, amount: item.amount};
    //   //   }),
    //   //   label,
    //   //   amount,
    //   // )
    //   //   .then((paymentStatus) => {
    //   //     switch (paymentStatus) {
    //   //       case PaymentStatus.CANCEL:
    //   //         console.log('Payment cancel')
    //   //         alert('Payment cancel');
    //   //         break;
    //   //       case PaymentStatus.SUCCESS:
    //   //         console.log('Payment success')
    //   //         alert('Payment success');
    //   //         break;
    //   //       default:
    //   //         console.log('Payment fail ' + paymentStatus);
    //   //         alert('Payment fail');
    //   //         break;
    //   //     }
    //   //   })
    //   //   .catch((err) => {
    //   //     console.log('error in performPayment ', err);
    //   //   });
    // },
    async googlePaymentClicked(type) {
      if (this.isMissingAgbs()) {
        return;
      }

      let self = this;
      this.safeUnload(30);

      const responseShow = document.getElementById('response');
      if (responseShow) {
        while (responseShow.firstChild) {
          responseShow.removeChild(responseShow.firstChild);
        }
      }
      let methods = []
      // add method support for google pay
      if (type === 'google-pay') {
        methods.push({
          supportedMethods: 'https://google.com/pay',
          data: this.getGooglePaymentsConfiguration()
        })
      }

      //remember the total of the paymentRequest to be able to detect changes of the total
      self.paymentRequestTotal = (0 + this.total);

      const details = {
        total: {
          label: "Bestellung bei " + store.state.brandName,
          amount: {currency: "EUR", value: '' + this.paymentRequestTotal}
        },
        // displayItems: [
        //   {
        //     label: "Bestellung zur Abholung",
        //     amount: { currency: "EUR", value: "110" },
        //   },
        // ],
        // shippingOptions: [
        //   {
        //     id: "standard",
        //     label: "Standard shipping",
        //     amount: { currency: "EUR", value: "10" },
        //     selected: true,
        //   },
        // ],
      };
      if (window.PaymentRequest) {
        self.goodpayHasPaymentRequest = true;
        const data = await this.createGooglePaymentRequest(methods, details)
          .show()
          .then(function (response) {
            // Dismiss payment dialog.
            response.complete('success');
            return response
          })
          .catch((err) => {
            self.stopLoading();
            let e = 'Code TGPC'; //takeaway google payment clicked
            console.log(e + ' error: ' + (err && err.constructor === Object ? JSON.stringify(err) : err));
            // self.notifyError(e);
            // ebus.$emit('throwError', getErrorDetails(err, 'TODOTHROW',  ' error=' +e);
            // alert('show() error! ' + err.name + ' error: ' + err.message);
          });
        console.log('data response: ' + (typeof data) + ' .... ' + data);
        if (data) {
          self.handleGooglePaymentResponse(self, data)
        }
        return true
      } else {
        self.goodpayHasPaymentRequest = false;
        self.stopLoading();
        console.log('PaymentRequest API is not available.');
        // alert('Google Pay is not available on this browser. Please use the application in Chrome or Safari instead');
      }
    },
    /**
     * Define your unique  Pay API configuration
     *
     * @returns {object} data attribute suitable for PaymentMethodData
     * https://developers.google.com/pay/api/android/reference/request-objects
     */
    getGooglePaymentsConfiguration() {
      return {
        environment: goodpayUtil.walletEnvironment,
        apiVersion: 2,
        apiVersionMinor: 0,
        merchantInfo: {
          // a merchant ID is available for a production environment after approval by Google
          // See {@link https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist
          // https://developers.google.com/pay/api/web/guides/test-and-deploy/integration-checklist
          merchantId: googlePayMerchantId,
          merchantName: store.state.brandName,
        },
        // transactionInfo: {
        //   totalPriceStatus: 'FINAL',
        //   totalPrice: '12.34',
        //   currencyCode 'EUR',
        // },
        shippingAddressRequired: false,
        allowedPaymentMethods: [{
          type: 'CARD',
          parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks: allowedCardNetworks
          },
          tokenizationSpecification: {
            type: 'PAYMENT_GATEWAY',
            parameters: {
              'gateway': goodpayUtil.googleGateway,
              'gatewayMerchantId': goodpayUtil.googleGatewayMerchantId,
            }
          }
        }],
        transactionInfo: getGoogleTransactionInfo(this.total),
      };
    },
    /**
     * Create a PaymentRequest
     *
     * @returns {PaymentRequest}
     */
    createGooglePaymentRequest(methods, details) {
      // options: add additional requirements for payment
      try {
        const options = {
          // requestPayerEmail: true,
          // requestPayerName: true,
          requestShipping: false,
        };
        let pr = new window.PaymentRequest(methods, details, options);
        console.log('Google PaymentRequest created successfully')
        return pr;
      } catch (error) {
        console.error('Error creating Google PaymentRequest:', error);
      }
    },
    // funtion create button google pay
    onGooglePayLoaded() {
      const paymentsClient = new google.payments.api.PaymentsClient();
      const self = this
      paymentsClient.isReadyToPay({
        apiVersion: 2,
        apiVersionMinor: 0,
        allowedPaymentMethods: [{
          type: 'CARD',
          parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks: allowedCardNetworks,
          },
        }],
      })
        .then(function (response) {
          if (response.result) {
            const button = paymentsClient.createButton({
              buttonColor: 'default',
              buttonType: 'buy', buttonRadius: 100,
              buttonLocale: 'de',
              buttonSizeMode: 'fill',
              onClick: {}
            });
            self.$refs.googlePay.appendChild(button);
          }
        })
        .catch(() => {
          console.log('PaymentRequest API not available.');
        });
    },
    /**
     * Process a PaymentResponse
     *
     * @param {PaymentResponse} response returned when a user approves the payment request
     */
    handleGooglePaymentResponse(self, response) {
      console.log('goodpay handleGooglePaymentResponse for response', response);
      self.googlePayResponse = util.cloneMe(response);
      // {
      //   "requestId": "d0cdea00-e453-42e9-b7f0-48ebfdc2eef2",
      //   "methodName": "https://google.com/pay",
      //   "details": {
      //   "apiVersionMinor": 0,
      //     "apiVersion": 2,
      //     "paymentMethodData": {
      //     "description": "Visa •••• 3011",
      //       "tokenizationData": {
      //       "type": "PAYMENT_GATEWAY",
      //         "token": "{\"signature\":\"MEUCIQCk4g1QnpcFQqLxW+CTyVKB7EAveB5/16DQJxOWGboKCwIgDPx6DDctNXfl2SSVtBzDZq/0+ZGPV9J5CZQ5ummXXag\\u003d\",\"intermediateSigningKey\":{\"signedKey\":\"{\\\"keyValue\\\":\\\"MFkwEwYHKoZIzj0CAQYIKoZIzj0DAQcDQgAEUHBdbUz4HueZYZP4Y4oWx4fXTO+yLEr91hhAocs/BQc9aPf8DistFnaTmw2jw+TmlMYo5rU8BOO9AMV7HfYJ1Q\\\\u003d\\\\u003d\\\",\\\"keyExpiration\\\":\\\"1696795161828\\\"}\",\"signatures\":[\"MEUCIEp5SBgZkD1G8gfwWchaFo0++8AbWepjnmA2S4DA//AtAiEAxLZQDErzlB2P3WhH7whXXSj4FR4n/cy1/lQB4k8uMGw\\u003d\"]},\"protocolVersion\":\"ECv2\",\"signedMessage\":\"{\\\"encryptedMessage\\\":\\\"FEWe4VudkgM8Cn1Nk07FHjyrZKDeMZZU0krBZkELPWZCy+PG5UCnCWeKKezBtvfDWA0ihKkxB6n4ElKRJ4y04gjaXV3+xMukwqhSmmIhF0TNTMpZDFhSSCpgarlpKkW/9+wlmq9Obt3TpY73IXHqrQ8n9NaxyGoh3TMIrBjuWjxL2fucoNLoaYBGDIIsva1m4ouFGiGHkdMFew7IGVuwppgaQBx3XITqqI4jLeBlfeNr//2NAaaPec+UK6lkIfb4ar0ZC0ESaoql+KyOLVbfUgnynBr4A4WgxKFzee3rODW8HgxRVcwNHGpF8nkTYgtwTf8FhnpgnUGSbAeN3KYC/gQ/xyaWtmY+0vz40KNY6rMMB8E1YFcO5mD/Uink0TEIcSRw99W9g4CKPCHeNH4LUn8ZJIDg/00JD8iujbFr8TckRRNJlHNsFjVg4bcAY89uctAFcDEoaN7vQS4/KDHOkxbSUtPj/Pd5JSxj4D/0HRpQWA7mG+5WAAs6QMQnMqiKRLu+4W60eDBvAUV3ZrHpLs5kPYJvd7ecNs9Xhw5RwMpeSOIXrjs7wq3CS+7BY/DJsVEyijopKA\\\\u003d\\\\u003d\\\",\\\"ephemeralPublicKey\\\":\\\"BGYDAxb+aR5iNWWaRv0Rp0XOn820ggpZTOvzTcn3gL4kF8vSeEuWV9oI6lbFePh0WGRQLmyQUG3P/tWGiNzbsrY\\\\u003d\\\",\\\"tag\\\":\\\"Zmc4RbxQcT8Y7h1ilZUPOAwMv4tkPcvZ5xVC9s2llHI\\\\u003d\\\"}\"}"
      //     },
      //     "type": "CARD",
      //       "info": {
      //       "cardNetwork": "VISA",
      //         "cardDetails": "3011"
      //     }
      //   }
      // },
      //   "shippingAddress": null,
      //   "shippingOption": null,
      //   "payerName": null,
      //   "payerEmail": null,
      //   "payerPhone": null
      // }
      console.log('goodpay GooglePay formattedResponse', response.toJSON());
      // const formattedResponse = document.createElement('pre');
      // let d = JSON.stringify(response.toJSON(), null, 2);
      // formattedResponse.appendChild(document.createTextNode(d));
      // document.getElementById('GoogleResponse')
      //   .appendChild(formattedResponse);

      //https://developers.google.com/pay/api/web/reference/response-objects#PaymentData
      let googlePayToken = response.details.paymentMethodData.tokenizationData.token;
      console.log('goodpay googlePayToken: ' + googlePayToken);

      //for development/sandbox we need to get the token from the simulator

      self.initGoodpayWalletTx(googlePayToken, false, true);
    },

    handleApplePaymentToken(self, token) {
      self.initGoodpayWalletTx(token, true, false);
    },

    // async submitGoodpayCreditFieldsTokenToPsp(token) {
    //   let self = this;
    //   self.commit('showLoading', true);
    //   // https://docs.saferpay.com/home/integration-guide/licences-and-interfaces/saferpay-fields#saferpay-fields-initialization
    //   let msg = {
    //     action: action$GoodpayFrontendApi,
    //     method: 'submitFieldsTokenToPsp',
    //     data: {
    //       fieldsToken: token,
    //     },
    //   };
    //   await xhr.xhrSend(true, msg, (reply) => {
    //     self.commit('showLoading', false);
    //     if (reply.ok && reply.response && reply.response.ok) {
    //       console.log('goodpay submitgGodpayCreditTokenToPsp was ok: ' + JSON.stringify(reply));
    //     } else {
    //       console.log('goodpay submitgGodpayCreditTokenToPsp error: ' + JSON.stringify(reply));
    //     }
    //   });
    // },

    isMissingAgbs() {
      if (!this.accceptedAgbs) {
        ebus.$emit('toast', 'Bitte zuerst unsere AGBs akzeptieren');
        return true;
      }
      return false;
    },

    submitCc() {
      if (this.isMissingAgbs()) {
        return;
      }
      //init transaction with aliasId
      this.initGoodpayCreditTx();
    },

    // submitCc() {
    //   // submit(); sends the entered hosted fields data to Saferpay.
    //   // store payment means data
    //   this.safeUnload();
    //   let self = this;
    //   SaferpayFields.submit({
    //     // https://docs.saferpay.com/home/integration-guide/licences-and-interfaces/saferpay-fields#saferpay-fields-initialization
    //     onSuccess: function (e) {
    //       //Callback on successful Submit
    //       // Once the onSuccess event is called, you need to forward the Saferpay Fields token to your server-backend,
    //       // in order to initialize the next step (see above) and also gather the RedirectUrl, to perform things like
    //       // 3D Secure and/or DCC. How you move the token to the backend is completely up to you. You can provide the
    //       // onSuccess event with an AJAX-method, to execute the initialization in the background on a successful submit
    //       // and forward the RedirectUrl to the fronend for a redirect this way, which you then can open in an iframe,
    //       // Lightbox, or as a full redirect. However a redirect via GET, or POST, towards your initialize-script,
    //       // is also an option. Refer to the above mentioned chapters, to learn, how to initialize a transaction, or
    //       // just save a card, using a Saferpay Fields token.
    //       console.log('goodpay submitCc onSuccess Payment token = '" + e.token + "'');
    //       self.gpFieldsToken = e.token;
    //       self.submitGoodpayCreditFieldsTokenToPsp(self.gpFieldsToken);
    //     },
    //     onError: function (evt) {
    //       //Callback on unsuccessful Submit
    //       console.log('goodpay submitCc onError ' + JSON.stringify(evt));
    //       ebus.$emit('showInfo', {
    //         title: 'Die Kredikarte wurde nicht erkannt: ' + evt.message,
    //       });
    //     }
    //   });
    // },

    getUserInfo() {
      let result = {
        btaste: bootstrap.getBtaste(),
        fuid: firebaseUtil.getFuid(),
        name: '' + this.name,
        email: util.sanitizeEmail(this.email),
        phone: util.sanitizePhone(this.phone),
      };
      // let bbnUser = this.$ls.get('bbnUser');
      // if (bbnUser) {
      //   if (bbnUser.token) {
      //     result.userToken = bbnUser.token
      //   }
      //   if (bbnUser.userId) {
      //     result.userId = bbnUser.userId
      //   }
      // }
      return result;
    },
    toggleInvoiceAddress() {
      this.isInvoiceAddressVisible = !this.isInvoiceAddressVisible;
    },
    // submitOrderWithCustomerCard(_this, _store) {
    //   console.log('submitOrderWithCustomerCard');
    //   _this.safeUnload();
    //   // let extend = {
    //   //   psp: isPayPal ? 'paypal': _this.psp,
    //   // }
    //   // Object.assign(paymentAuth, extend);
    //   let updates = {
    //     storno: false,
    //     sentToPos: false,
    //     useCustomerCard: true,
    //     // sentPaymentToPos: false,
    //     // authCompleted: true, //authCompleted may be true already by requires_capture state
    //     // authCompletedAt: Date.now(),
//authorisedTotal: 0 + _this.total,
    //     psp: 'customerCard',
    //     // captured: false,
    //     // paymentAuth: paymentAuth
    //   };
    //
    //   let finalOrder = Object.assign(util.cloneMe(_this.order), updates);
    //   _store.commit('updateOrder', finalOrder);
    //
    //   let order = util.cloneMe(_this.order);
    //   if (!order) {
    //     throw 'order not found for submitOrderWithCustomerCard';
    //   }
    //   let uniqueOrderId = order.uniqueOrderId;
    //   let updateOrder = {
    //     action: qconst.action$DocUpserter,
    //     collectionName: 'orders',
    //     updates: updates,
    //     subjectKey: {
    //       key: 'uniqueOrderId',
    //       value: uniqueOrderId
    //     },
    //     autoRetry: true,
    //   };
    //   xhr.xhrSend(true, updateOrder, (reply) => {
    //     if (reply && reply.ok) {
    //       console.log('single order successfully updated with useCustomerCard');
    //       _store.commit('deleteAllCartItems');
    //       _this.logPurchase();
    //       setTimeout(() => {
    //         setGlobalKeyValue('contextPostOrder', true);
    //         _this.$router.replace({
    //           name: 'Bestellung',
    //           params: {
    //             uniqueOrderId: uniqueOrderId
    //           }
    //         });
    //         ebus.$emit('showInfo', {
    //           title: 'Die Bestellung wurde erfolgreich übermittelt',
    //           text: ''
    //         });
    //       }, 1200);
    //     } else {
    //       console.log('single order reply not ok for customerCard');
    //       //retry
    //       console.log('retry submitOrderWithCustomerCard...');
    //       setTimeout(() => {
    //         _this.submitOrderWithCustomerCard(_this, _store);
    //       }, 800);
    //     }
    //   }, (err) => {
    //     //retry
    //     console.log('retry submitOrderWithCustomerCard...');
    //     setTimeout(() => {
    //       _this.submitOrderWithCustomerCard(_this, _store);
    //     }, 800);
    //   });
    // },

    _saveOrder(retryCount) {
      console.log('_saveOrder');
      if (!retryCount) {
        retryCount = 0;
      }
      let checkpoints = 0;
      try {
        store.commit('showLoading', true);
        // this.safeUnload();
        let order;
        ++checkpoints;
        order = this.generateOrder();
        ++checkpoints;

        let msg = {
          action: qconst.action$SaveNewOrder,
          order: order,
          // captchaText: '' + this.captchaInput
        };

        let timeout = qconst.withPosApi ? (60 * 1000) : (10 * 1000);
        xhr.xhrSend(true, msg, (reply) => {
          //either ok with orderId or notOk
          store.commit('showLoading', true);
          ++checkpoints;
          console.log('??? SaveNewOrder reply OK = ' + !!reply.ok);
          if (reply.ok) {
            ++checkpoints;
            this.order = reply;

            let finalOrder = Object.assign(util.cloneMe(this.order), reply);
            store.commit('updateOrder', finalOrder);

            const checkoutItems = cloneMe(store.getters.cartItems);
            ebus.$emit('fastUpdateInventory', checkoutItems);

            store.commit('deleteAllCartItems');

            let uniqueOrderId = finalOrder.uniqueOrderId;

            if(store.getters.isKiosk){
              console.log('sending triggerBonPrintOrder');
              ebus.$emit('postToWindowskiosk', {
                action: 'triggerBonPrintOrder',
                order: cloneMe(finalOrder),
                cb: 'cb-triggerBonPrintOrder'
              });
            }

            setTimeout(() => {
              if (store.getters.isKiosk) {
                setTimeout(() => {
                  ebus.$emit('resetKiosk');
                }, kioskResetTimeoutAfterOrder);
              }
              this.$router.replace({
                name: 'Bestellung',
                params: {
                  uniqueOrderId: uniqueOrderId
                }
              });
              ebus.$emit('showInfo', {
                title: 'Die Bestellung wurde erfolgreich durchgeführt',
                text: ''
              });
            }, 1200);

            // this.$ls.set('lastOrder', order);
            // // ebus.$emit('orderSuccess');
            //
            // // this.logPurchase();
            // ++checkpoints;
            // store.commit('deleteAllCartItems');
            // ++checkpoints;
            // this.$router.replace({name: 'Bestellung', params: {uniqueOrderId: order.uniqueOrderId}});
            // this.$router.replace({name: 'Bestaetigung'});
          } else {
            store.commit('showLoading', false);
            if (reply.captchaError || reply.secTokenError) {
              ebus.$emit('forceReload');
              // this.notifyError('Der eingegebenen Buchstaben sind ungültig.', 'Bitte gib die Buchstaben im letzen Schritt erneut ein!');
            } else if (reply.forceReload) {
              alert('Hinweis: Nach einer kurzen Aktualisierung der App, die automatisch durchgeführt wird,' +
                ' kannst du deine Bestellung abschließen.');
              ebus.$emit('forceReload');
            } else {
              checkpoints += 300;
              // if (reply.captchaError) {
              //     checkpoints += 200;
              //     this.notifyError('Der eingegebenen Buchstaben sind ungültig.', 'Bitte gib die Buchstaben im letzen Schritt erneut ein!');
              // } else {
              // checkpoints += 300;
              this.notifyError('Fehler bei der Verarbeitung der Bestellung', 'Bitte versuche es erneut');
              ebus.$emit('pullBuyersProfile');
              // }
              // this.reloadCaptcha();
              // checkpoints += 10000;

              // store.commit('showLoading', false);
              //
              ebus.$emit('throwError', getErrorDetails('Error in save new order takeaway, checkpoints: ' + checkpoints));
            }
          }
        }, (err) => {
          store.commit('showLoading', false);
          checkpoints += 20000;
          ebus.$emit('throwError', getErrorDetails('Transport error in save new order takeaway; checkpoints: ' + checkpoints + ' retryCount: ' +
            retryCount + ' error:' + err.message));
          //this.notifyError('Fortschritt ' + retryCount + 1 + '/' + 5, '');

          if (!retryCount || retryCount < 2) {
            //retry
            let r = ++retryCount;
            setTimeout(() => {
              this._saveOrder(r);
            }, 2200);
          } else {
            // store.commit('showLoading', false);
            this.notifyError('Verbindungsfehler', 'Bitte versuche es direkt nochmal');
            console.log('Error Verbindungsfehler');
            // setTimeout(() => {
            //     ebus.$emit('reload', true)
            // }, 2500);
          }
        }, timeout);
      } catch (e) {
        store.commit('showLoading', false);
        checkpoints += 30000;
        ebus.$emit('throwError', getErrorDetails('Exception in save new order takeaway: ' + e.message + '; checkpoints: ' + checkpoints));
        console.log('!!!!! error: ' + e.message);
      }
    },
    preInit() {
      if (this.checkEnter()) {
        if (store.state.onlineServiceFee) {
          let item = {
            id: 'specialUniqueOnlineServiceFee',
            articleNo: '',
            posId: '5007',
            // delay: this.selectedCat.delay,
            cartItemId: util.generateClientId(),
            isOffer: false, //!!(size.offerId), //offers and cartItems ar always size specific
            type: qconst.type$generic,
            nameToDisplay: 'Online Servicegebühr', //itemClone.nameDE,
            description: '', // + itemClone.descriptionDE,
            // days: itemClone.days,
            notes: '',
            // gramm: itemClone.gramm,
            // unikat: !!(itemClone.unikat),
            sizePrice: store.state.onlineServiceFee, // sizePrice,
            sumOfExtras: 0, // sizePrices.sumOfExtras,// this.total - (size.price * size.aaaCount),
            itemTotal: store.state.onlineServiceFee, //sizePrices.sizeTotal + sizePrices.sumOfExtras,
            count: 1,
            vol: '', //size.vol,
            extras: [
              // {name:'',price:0}
            ],
            extrasToDisplay: [], //['eins', 'zwe' ] //or empty array
            variantsSelected: [], //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
            stylesSelected: [] //['234234asdasd', '567567gfddfg'] //unsique ids within the complete menu
          };
          store.commit('addItemToCart', {
            item: item, addSilent: true
          });
        }

        // util.jumpToTop();
        this.init('preInit');
        // firebaseUtil.gevent('begin_checkout', {
        //     currency: 'EUR',
        //     value: this.total,
        //     items: util.cloneMe(firebaseUtil.getGitemsFromCart(store.getters.cartItems))
        // });
      }
    },
    phoneKeydown(e) {
      util.phoneKeydown(e);
    },
    hideToolbar() {
      store.commit('hideToolbar', true);
    },
    unhideToolbar() {
      store.commit('hideToolbar', false);
    },
    // clickRadio() {
    //     util.delayScroll('paymentRadios');
    // },
    // preselectCreditCard() {
    //     let pMethods = this.paymentMethods;
    //     // let pMethods =  util.cloneMe(store.getters.paymentMethods);
    //     if (pMethods && pMethods.length > 0) {
    //         this.selectMethod(pMethods[0]);
    //     }
    // },

    showLieferzeiten() {
      this.timesInfoDialog = true;
    },

    // handleScrollingInStep2() {
    //     util.delayScroll('hintStep2');
    // },

    handleScrollingInStep3() {
      // util.delayScroll('paymentRadios');
    },

    // attachPaymentMethodToStripeCustomer(_paymentMethodId, cb) {
    //     let msg = {
    //         action: qconst.action$AttachPaymentMethodToStripe,
    //         uid: bootstrap.getBtaste(),
    //         stripeCustomerId: store.state.stripeCustomerId,
    //         paymentMethodId: _paymentMethodId,
    //     };
    //     // if (firebaseUtil.getUser()) {
    //     //     msg.fuid = firebaseUtil.getUser().uid
    //     // }
    //     xhr.xhrSend(true, msg, (reply) => {
    //         if (reply.ok) {
    //             console.log('??? reloadBuyersProfile...');
    //             setTimeout(() => {
    //                 ebus.$emit('pullBuyersProfile');
    //             }, 1200);
    //         } else {
    //             console.log('??? reply of  action$AttachPaymentMethodToStripe not ok; ' +
    //                 'maybe the payment method already exits ');
    //             // this.notifyError('Unerwarteter Fehler', 'Bitte versuche es erneut');
    //         }
    //         cb(true);
    //     }, (err) => {
    //         this.notifyError('Unerwarteter Fehler', err);
    //         cb(false);
    //     });
    // },

    updateTotal() {
      this.total = 0 + roundToTwo(store.getters.payerSum) - this.totalSavedByDiscounts;
      // if (this.usecase === 'delivery') {
      //     // let fee = 0;
      //     try {
      //         this.total = store.getters.payerSum + this.deliveryFee;
      //     } catch (e) {
      //         console.log('error updating total: ' + e);
      //     }
      // } else
      // if (this.usecase === qconst.usecase$delivery) {
      //     // let fee = 0;
      //     try {
      //         this.total = 0 + roundToTwo(store.getters.payerSum) + store.state.deliveryFee;
      //     } catch (e) {
      //         console.log('error updating total: ' + e);
      //     }
      // }
      // if (this.usecase === qconst.usecase$takeAway) {
      //     // let fee = 0;
      //     try {
      //         this.total = store.state.takeAwayPayerSum;//+ store.getters.selectedStore.fee;
      //     } catch (e) {
      //         console.log('error updating total: ' + e);
      //     }
      // }
    },

    // lazyCreateEarlyPaymentIntent() {
    //     if (this.earlyClientSecret.length > 0) {
    //         return;
    //     }
    //     let msg = {
    //         action: qconst.action$StripeCreateEarlyPaymentIntent,
    //         restaurantId: store.state.restaurantData.restaurantId,
    //         amount: this.total,
    //         userInfo: util.cloneMe(store.state.user),
    //         stripeCustomerId: store.state.stripeCustomerId,
    //         // paymentMethodId: this.selectedPaymentMethodId
    //     };
    //     xhr.xhrSend(true, msg, (reply) => {
    //         if (reply.ok) {
    //             let paymentIntentId = reply.paymentIntentId;
    //             let clientSecret = reply.clientSecret;
    //             console.log('??? early paymentIntentId=' + paymentIntentId);
    //             console.log('??? early clientSecret=' + clientSecret);
    //             this.$nextTick(() => {
    //                 let status = reply.status;
    //                 // this.paymentIntentAmount = msg.amount;
    //                 this.earlyPaymentIntentId = paymentIntentId;
    //                 this.earlyClientSecret = clientSecret;
    //                 // this.paymentIntentStatus = status;
    //                 // this.orderNumber = reply.orderNumber;
    //                 // this.uniqueOrderId = reply.uniqueOrderId;
    //                 // this.createdAt = reply.createdAt; //server-side createdAt
    //
    //                 console.log('???status of early paymentIntent: ' + status);//requires_payment_method
    //
    //                 this.createPaymentRequest();
    //
    //                 // if (status === 'requires_action') {
    //                 //     this.handleRequiresAction();
    //                 // } else if (status === 'requires_capture') {
    //                 //     // this.notifyInfo('Die Zahlung wurde erfolgreich autorisiert');
    //                 //     this.saveOrder();
    //                 // } else {
    //                 //     this.notifyError('Unbekannter Status: ', status);
    //                 // }
    //             });
    //         }
    //     }, (err) => {
    //         console.log('??? error creating early intent: ' + err);
    //     })
    // },

    checkEnter() {
      try {
        if (
          // (!this.$ls.get('asGuest',true) && store.getters.loggedIn === false) ||
          store.getters.cartItems.length === 0 ||
          !store.getters.orderingEnabled
        ) {
          ebus.$emit('gotoStart');
          return false;
        }
        return true;
      } catch (e) {
        console.log('Error in checkEnter...');
        ebus.$emit('gotoStart');
        return false;
      }
    },

    preselectFields() {
      if (store.getters.isKiosk) {
        return;
      }
      try {
        let fd = this.$ls.get('formData') || {};
        this.hasFd = !util.isEmptyObject(fd);
        if (this.hasFd) {
          if (fd.name) {
            this.name = fd.name;
          }
          if (fd.email) {
            this.email = util.sanitizeEmail(fd.email);
          }
          if (fd.phone) {
            this.phone = util.sanitizePhone(fd.phone);
          }
          if (fd.invoiceAddress && fd.invoiceAddress.street.length > 0) {
            this.invoiceAddress = fd.invoiceAddress;
          }
          // if (fd.note) {
          //   this.note = fd.note;
          // }
        } else {
          // this.invoiceAddress.plz = store.state.defaultPlz; //default PLZ
          // this.invoiceAddress.city = store.state.defaultCity; //default City
        }
        let fbUser = firebaseUtil.getUser();
        if (fbUser) {
          if (fbUser.displayName) {
            this.name = fbUser.displayName;
          }
          if (fbUser.email) {
            this.email = fbUser.email;
          }
          if (fbUser.phoneNumber) {
            this.phone = fbUser.phoneNumber;
          }
        }
        this.resetValidation();
        // let bbnUser = this.$store.getters.bbnUser;
        // if (bbnUser?.email?.length) {
        //   this.email = bbnUser.email;
        // }
        //
        // let geschnittenList = getGlobalValue('geschnittenList');
        // if (geschnittenList) {
        //   let x = [];
        //   for (let itm of geschnittenList) {
        //     x.push('Geschnitten: ' + itm.nameToDisplay);
        //   }
        //   this.note = x.join(', ').slice(0, -2);
        // }

      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('error in load form: ' + e.message));
      }
    },

    init() {
      try {
        this.currentStep = 1;
        this.consent = false;

        this.initTimesArray();

        //preselect time
        this.preselectTime();


        // this.initTimesArray();
        //
        // //preselect time
        // let st = store.getters.selectedTime;
        // for (let t of this.times) {
        //     if (t.value === st.value) {
        //         this.time = t;
        //         break;
        //     }
        // }

        //init stores
        // this.stores = util.cloneMe(store.getters.stores);

        // //preslect autoModel the store from the local store
        // let lsSelectedStore = this.$ls.get('selectedStore');
        // if (lsSelectedStore) {
        //     let lss = JSON.parse(lsSelectedStore);
        //     if (lss.plz && lss.strasse) {
        //         store.getters.selectedStore = util.cloneMe(lss);
        //         this.autoModel = {
        //             displayName: lss.strasse + ', ' + lss.plz + ' ' + lss.ort,
        //             obj: lss
        //         };
        //     }
        // }

        //preselect psp
        // if (this.showBar) {
        //     this.psp = 'bar';
        // } else if (this.showStripe) {
        //     this.psp = 'stripe';
        // } else if (this.showPaypal) {
        //     this.psp = 'paypal';
        // }

        //fill name, email, phone, invoiceAddress and deliveryAddress as possible
        // if (!this.asGuest) {
        //     let user = firebaseUtil.getUser();
        //     if (user) {
        //         if (user.displayName && user.displayName.indexOf(' ') > 0) {
        //             this.name = user.displayName;
        //         }
        //         this.email = user.email;
        //         this.phone = user.phoneNumber;
        //         // //init vorname und nachname
        //         // this.vorname = user.displayName.substring(0, user.displayName.indexOf(' '));
        //         // this.nachname = user.displayName.substring(user.displayName.indexOf(' '), user.displayName.length);
        //     }
        // }

        this.preselectFields();

        // if(this.invoiceAddress.street.length === 0){
        //     //preselect company
        //     let _company = this.$ls.get('company');
        //     if (_company) {
        //         this.invoiceAddress.company = _company;
        //     }
        //
        //     let _invoiceAddress = this.$ls.get('invoiceAddress');
        //     if (_invoiceAddress) {
        //         let ia = JSON.parse(_invoiceAddress);
        //         if (ia.company) {
        //             this.invoiceAddress.company = ia.company;
        //         }
        //         if (ia.street) {
        //             this.invoiceAddress.street = ia.street
        //         }
        //         if (ia.plz) {
        //             this.invoiceAddress.plz = ia.plz
        //         }
        //         if (ia.city) {
        //             this.invoiceAddress.city = ia.city
        //         }
        //         // if (ia.etage) {
        //         //     this.invoiceAddress.etage = ia.etage
        //         // }
        //     }
        // }
        //
        // if(this.deliveryAddress.street.length === 0){
        //     let _deliveryAddress = this.$ls.get('deliveryAddress');
        //     if (_deliveryAddress) {
        //         let da = JSON.parse(_deliveryAddress);
        //         if (da.company) {
        //             this.deliveryAddress.company = da.company;
        //         }
        //         if (da.street) {
        //             this.deliveryAddress.street = da.street
        //         }
        //         if (da.plz) {
        //             this.deliveryAddress.plz = da.plz
        //         }
        //         if (da.city) {
        //             this.deliveryAddress.city = da.city
        //         }
        //         if (da.etage) {
        //             this.deliveryAddress.etage = da.etage
        //         }
        //     }
        // }


        // this.usecase = store.state.goforTakeaway ? 'takeAway' : 'delivery';

        //Only for delivery usecase
        // let _deliveryAddress = this.$ls.get('deliveryAddress');
        // if (_deliveryAddress) {
        //     let da = JSON.parse(_deliveryAddress);
        //     if (da.company) {
        //         this.deliveryAddress.company = da.company;
        //     }
        //     if (da.street) {
        //         this.deliveryAddress.street = da.street;
        //     }
        //     if (da.plz) {
        //         this.deliveryAddress.plz = da.plz;
        //     }
        //     if (da.city) {
        //         this.deliveryAddress.city = da.city;
        //     }
        //     if (da.etage) {
        //         this.deliveryAddress.etage = da.etage;
        //     }
        // }


        this.updateTotal();
        // this.updateMinOrderAmount();
        // this.updateDeliveryFee();


        // //init times array
        // let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
        // let allMinutes = ['00', '15', '30', '45'];
        //
        // // let isFirstTime = true;
        //
        // //day1
        // if (store.state.day1.opened) {
        //     this.internalDaySelected = '1';
        //     let relevantHours = allHours.filter(this.allowedHours);
        //     let rNow = util.getCurrentRemoteTime();
        //     let currentHour = rNow.getHours();
        //     let currentMinutes = rNow.getMinutes();
        //     let zieltermin = util.calculateZielterminOfToday(store.getters.appconfig.takeAway.delayInMinutes);
        //
        //     console.log('???? zieltermin hours = ' + zieltermin.getHours());
        //
        //     for (let hour of relevantHours) {
        //
        //         //ignore hours before zieltermin
        //         if (hour < zieltermin.getHours()) {
        //             continue;
        //         }
        //
        //         let h = '' + hour;
        //         if (hour < 10) {
        //             h = '0' + h;
        //         }
        //
        //         for (let minute of allMinutes) {
        //             if (hour === currentHour) {
        //
        //                 let _minute = parseInt(minute, 10);
        //
        //                 //ignore minutes before now
        //                 if (_minute <= currentMinutes) {
        //                     continue;
        //                 }
        //
        //                 //ignore minutes before zieltermin
        //                 if (_minute < zieltermin.getMinutes()) {
        //                     continue;
        //                 }
        //             }
        //             this.times1.push({
        //                 value: h + ':' + minute
        //             });
        //             // if (isFirstTime) {
        //             //     this.time = h + ':' + minute;
        //             //     isFirstTime = false;
        //             // }
        //         }
        //     }
        //     // this.preselectDay1();
        // }
        //
        // //day2
        // if (store.state.day2.opened) {
        //     this.internalDaySelected = '2';
        //     let relevantHours = allHours.filter(this.allowedHours);
        //     for (let hour of relevantHours) {
        //         let h = '' + hour;
        //         if (hour < 10) {
        //             h = '0' + h;
        //         }
        //         for (let minute of allMinutes) {
        //             this.times2.push({
        //                 value: h + ':' + minute
        //             });
        //             // if (isFirstTime) {
        //             //     this.time = h + ':' + minute;
        //             //     isFirstTime = false;
        //             // }
        //         }
        //     }
        //     // this.preselectDay1();
        // }

        //the payment intent is already ready to go
      } catch (e) {
        console.log('Error: ' + e.message);
        ebus.$emit('info', 'Fehler bei der Initialisierung');
      }
    },//eof init

    preselectTime() {
      //note: store.getters.selectedTime is only required if the time
      // gets selected on other pages than checkout

      // let st = store.getters.selectedTime;
      // if (this.selectedAbholDatum === 'Heute') {
      //     for (let t of this.timesToday) {
      //         if (t.value === st.value) {
      //             this.time = t;
      //             break;
      //         }
      //     }
      // } else {
      //     for (let t of this.timesTomorrow) {
      //         if (t.value === st.value) {
      //             this.time = t;
      //             break;
      //         }
      //     }
      // }
    },

    calcEarliestAbholung() {
      let delayInMinutes = util.calcDelayInMinutes(store.getters.appconfig.takeAway.delayInMinutes, util.cloneMe(store
        .getters.cartItems));
      return util.calculateZielterminOfToday(delayInMinutes); // returns a Date
    },

    initTimesArray() {
      console.log('initTimesArray...');
      let appconfig = util.cloneMe(store.getters.appconfig);
      if (!appconfig.takeAway.openingHours['1']) {
        //XHR has not finished loading the appconfig yet
        return;
      }
      //init times array
      this.timesToday.splice(0, this.timesToday.length);
      this.timesTomorrow.splice(0, this.timesTomorrow.length);

      //takwaways either on today or tomorrow so we need to filter the hours
      let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
      // let allMinutes = ['00', '15', '30', '45'];
      // let moreMinutes = ['00', '5', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

      //calculate delayInMinutes
      let delayInMinutes = util.calcDelayInMinutes(appconfig.takeAway.delayInMinutes, util.cloneMe(store.getters
        .cartItems));

      //Init Heute timesToday
      // this.internalDaySelected = '1';
      let today = util.getDayOfWeek(new Date());
      let ohsToday = appconfig.takeAway.openingHours['' + today];
      // console.log('openedToday = '+ohsToday.opened);
      if (ohsToday.opened) {
        let relevantHours = allHours.filter((h) => {
          return this.allowedHours(h, ohsToday)
        });

        if (relevantHours) {
          // let nextDay = util.getNextDay();
          let rNow = new Date();
          let currentHour = rNow.getHours();
          let currentMinutes = rNow.getMinutes();
          let earliestAbholung = this.calcEarliestAbholung();
          // console.log('???? earliestAbholung utc = ' + earliestAbholung.getTime());

          for (let hour of relevantHours) {

            //ignore hours before zieltermin
            if (hour < earliestAbholung.getHours()) {
              continue;
            }

            let h = '' + hour;
            if (hour < 10) {
              h = '0' + h;
            }

            this.generateMinutes(delayInMinutes, h, hour, currentHour, currentMinutes, ohsToday, this.timesToday,
              true);
          }//eof of init today
        }

      }
      if (this.timesToday.length > 0) {
        this.abholDatumArray[0].value = 'Heute';
      } else {
        this.abholDatumArray[0].value = 'Heute geschlossen';
      }


      //init Morgen timesTomorrow
      // this.internalDaySelected = '1';
      let tomorrow = util.getNextDay();
      let ohsTomorrow = appconfig.takeAway.openingHours['' + tomorrow];
      if (ohsTomorrow.opened) {
        let relevantHours2 = allHours.filter((h) => {
          return this.allowedHours(h, ohsTomorrow)
        });
        // let nextDay = util.getNextDay();
        // let rNow = new Date();
        // let currentHour = rNow.getHours();
        // let currentMinutes = rNow.getMinutes();
        // let zieltermin = util.calculateZielterminOfToday(appconfig.takeAway.delayInMinutes);
        if (relevantHours2) {
          for (let hour of relevantHours2) {

            //ignore hours before zieltermin
            // if (hour < zieltermin.getHours()) {
            //     continue;
            // }

            let h = '' + hour;
            if (hour < 10) {
              h = '0' + h;
            }

            this.generateMinutes(delayInMinutes, h, hour, null, null, ohsTomorrow, this.timesTomorrow, false);


          }//eof of init tomorrow
        }


      }
      if (this.timesTomorrow.length > 0) {
        this.abholDatumArray[1].value = 'Morgen';
      } else {
        this.abholDatumArray[1].value = 'Morgen geschlossen';
      }


      // this.preselectDay1();
    },

    generateMinutes(delayInMinutes, h, hour, currentHour, currentMinutes, ohs, timesArray, forToday) {
      try {
        let lessMinutes = ['00', '15', '30', '45'];
        let allMinutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];
        for (let minute of allMinutes) {
          let _minute = parseInt(minute, 10);

          let utcValue;
          if (forToday) {
            utcValue = new Date();
          } else {
            utcValue = util.addDays(util.getCurrentRemoteTime(), 1);
          }
          // console.log('checkout utc = ' + nd.getTime());
          // console.log('checkout utc date = ' + nd);
          // console.log('checkout utc locale = ' + nd.toLocaleString());
          utcValue.setHours(hour);
          utcValue.setMinutes(_minute);
          let diff2Now = utcValue.getTime() - Date.now();
          let isWithin60Minutes = diff2Now < (1000 * 60 * 60);
          if (isWithin60Minutes || forToday) {
            //ignore times if delayInMinutes from now is too small
            if (diff2Now < (delayInMinutes * 60 * 1000)) {
              continue;
            }
          }

          if (forToday) {
            if (hour === currentHour) {
              //ignore minutes before now
              if (_minute <= currentMinutes) {
                continue;
              }
            }
          }

          if (!isWithin60Minutes) {
            if (!lessMinutes.includes(minute)) {
              continue; //less minutes for everything later than 60 minutes
            }
          }

          if (hour === ohs.a.fromHour) {
            if (!(ohs.a.fromMinute <= _minute)) {
              continue
            }
          }
          if (hour === ohs.a.tillHour) {
            if (!(_minute <= ohs.a.tillMinute)) {
              continue
            }
          }
          if (hour === ohs.b.fromHour) {
            if (!(ohs.b.fromMinute <= _minute)) {
              continue
            }
          }
          if (hour === ohs.b.tillHour) {
            if (!(_minute <= ohs.b.tillMinute)) {
              continue
            }
          }

          timesArray.push({
            value: h + ':' + minute,
            display: 'ca. ' + h + ':' + minute + ' Uhr',
            utc: utcValue.getTime()
          });
        }
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('Exception in generateMinutes: ' + e.message));
      }
    },

    // initTimesArray() {
    //     //init times array
    //     //takwaways is always on the next day so we don't neet to filter the times
    //     let allHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
    //     let allMinutes = ['00', '30'];
    //
    //     // let isFirstTime = true;
    //
    //     // this.internalDaySelected = '1';
    //     let relevantHours = allHours.filter(this.allowedHours);
    //     let nextDay = util.getNextDay();
    //     let relevantDay = store.getters.selectedStore.openingHours['' + nextDay];
    //     // let rNow = util.getCurrentRemoteTime();
    //     // let currentHour = rNow.getHours();
    //     // let currentMinutes = rNow.getMinutes();
    //     // let zieltermin = util.calculateZielterminOfToday(appconfig.takeAway.delayInMinutes);
    //
    //     // console.log('???? zieltermin hours = ' + zieltermin.getHours());
    //
    //     for (let hour of relevantHours) {
    //
    //         //ignore hours before zieltermin
    //         // if (hour < zieltermin.getHours()) {
    //         //     continue;
    //         // }
    //
    //         let h = '' + hour;
    //         if (hour < 10) {
    //             h = '0' + h;
    //         }
    //
    //         for (let minute of allMinutes) {
    //             let minNum = 0;
    //             if (minute !== '00') {
    //                 minNum = 30;
    //             }
    //
    //             if (hour === relevantDay.a.fromHour) {
    //                 if (!(relevantDay.a.fromMinute <= minNum)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.a.tillHour) {
    //                 if (!(minNum <= relevantDay.a.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.b.fromHour) {
    //                 if (!(relevantDay.b.fromMinute <= minNum)) {
    //                     continue
    //                 }
    //             }
    //             if (hour === relevantDay.b.tillHour) {
    //                 if (!(minNum <= relevantDay.b.tillMinute)) {
    //                     continue
    //                 }
    //             }
    //
    //             // if (hour === currentHour) {
    //             //
    //             //     let _minute = parseInt(minute, 10);
    //             //
    //             //     //ignore minutes before now
    //             //     if (_minute <= currentMinutes) {
    //             //         continue;
    //             //     }
    //             //
    //             //     //ignore minutes before zieltermin
    //             //     if (_minute < zieltermin.getMinutes()) {
    //             //         continue;
    //             //     }
    //             // }
    //
    //             let nd = util.addDays(util.getCurrentRemoteTime(), 1);
    //             // console.log('checkout utc = ' + nd.getTime());
    //             // console.log('checkout utc date = ' + nd);
    //             // console.log('checkout utc locale = ' + nd.toLocaleString());
    //             nd.setHours(hour);
    //             nd.setMinutes(minNum);
    //
    //
    //             this.times.push({
    //                 value: h + ':' + minute,
    //                 display: h + ':' + minute + ' Uhr',
    //                 utc: nd.getTime()
    //             });
    //             // if (isFirstTime) {
    //             //     this.time = h + ':' + minute;
    //             //     isFirstTime = false;
    //             // }
    //         }
    //     }
    //     // this.preselectDay1();
    // },

    // preselectDay1() {
    //     //preselect first option
    //     if (this.times1.length > 0) {
    //         this.time = this.times1[0].value;
    //     }
    // },

    // preselectDay2() {
    //     //preselect first option
    //     if (this.times2.length > 0) {
    //         this.time = this.times2[0].value;
    //     }
    // },

    allowedHours(h, dayOh) {
      // let rNow = Date.now();
      // let currentHour = rNow.getHours();

      // if (isToday) {
      //     //ignore hours before now
      //     if (h < currentHour) {
      //         return false;
      //     }
      // }
      //check period a
      let matchesA = dayOh.a.fromHour <= h && h <= dayOh.a.tillHour;
      if (matchesA) {
        return true;
      }
      if (dayOh.b.fromHour > -1 && dayOh.b.fromHour !== dayOh.b.tillHour) {
        return dayOh.b.fromHour <= h && h <= dayOh.b.tillHour;
      }
      return false;
    },

    gotoSummary() {
      this.$router.push({name: 'Korb'});
    },

    gotoAccount() {
      this.$router.push({name: 'Account'});
    },

    changeFiliale() {
      this.$router.push({name: 'Filialen', query: {select: 'true'}});
    },

    //Überprüfe deine Daten
    finishStep1() {
      this.$nextTick(() => {
        this.refreshForm();
        if (!this.validate() || !this.step1Ok) {
          this.initialTry = true;
          return;
        }

        this.email = util.removeSpaces(this.email);

        this.saveForm();

        //double check
        // let err = this.step1Ok();
        // if () {
        //     return;
        // }

        // if (!store.state.user.name || store.state.user.name.length < 3) {
        //     ebus.$emit('showInfo', {title: 'Gib deinen Namen ein, um fortzufahren'});
        //     return;
        // }

        if (store.getters.cartSum === 0) {
          this.$router.push({
            name: 'Korb'
          });
          return;
        }

        //Prüfe den Mindestbestellwert
        if (store.getters.cartSum < store.getters.appconfig.takeAway.minOrderAmount) {
          // if (store.getters.cartSum < store.getters.selectedStore.minOrderAmount) {
          // if (store.getters.cartSum < this.minOrderAmount) {
          //     if (this.usecase === 'delivery') {
          this.$router.push({name: 'Korb'});
          ebus.$emit('showInfo', {
            title: 'Bitte beachte den Mindestbestellwert von ' +
              util.getLocalPrice(store.getters.appconfig.takeAway.minOrderAmount)
          });
          return;
          // }
        }

        //Prüfe Verfügbarkeit aller Waren
        // let itemsNotAvailable = [];
        // for (let itm of store.getters.cartItems) {
        //     if (itm.couponCode) {
        //         continue;
        //     }
        //     if (!plausi.itemAvailableTomorrow(itm)) {
        //         itemsNotAvailable.push(itm);
        //     }
        // }
        // if (itemsNotAvailable.length > 0) {
        //     let names = itemsNotAvailable.map(itm => itm.nameToDisplay);
        //     // let filialeName = store.getters.selectedStore.strasse + ', ' + store.getters.selectedStore.ort;
        //     ebus.$emit('showInfo', {
        //         title: 'Folgende Waren sind morgen nicht verfügbar: ' + this.$options.filters.stringList(names),
        //         text: 'Bitte entfernen Sie nicht verfügbare Waren aus dem Korb.'
        //     });
        //     this.$router.push({name: 'Korb'});
        //     return;
        // }

        this.updateTotal();

        // store.commit('showLoading', true);
        this.currentStep = 2;
        util.closeSoftKeyBoard();
        if (iframe.isInIframe()) {
          util.jumpToTop();
        } else {
          util.delayScroll('abholung');
        }
      });
    },

    safeUnload(seconds, self) {
      try {
        if (!self) {
          self = this;
        }
        if (isNaN(seconds)) {
          seconds = 6;
        }
        let now = Date.now();
        let millis = seconds * 1000;
        let targetTime = now + millis;
        self.unloadTargetTime = targetTime
        store.commit('showLoading', true);
        setTimeout(() => {
          let diff = Date.now() - self.unloadTargetTime;
          if (diff > -600 && diff < 600) {
            store.commit('showLoading', false);
          }
        }, millis);
      } catch (e) {
        console.log('error in safeUnload: ' + e.message);
      }
    },

    stopLoading(self) {
      if (!self) {
        self = this;
      }
      self.loading = false;
      store.commit('showLoading', false);
      this.unloadTargetTime = 0;
    },

    //Abholzeit
    finishStep2() {
      this.$nextTick(() => {
        try {
          // //Prüfe die Öffnungszeit
          // let nextDay = util.getNextDay();
          // let oh = store.getters.selectedStore.openingHours['' + nextDay];
          // if (!oh.opened) {
          //     ebus.$emit('showInfo', {
          //         title: 'Das Restaurant hat morgen geschlossen',
          //         text: 'Bitte beachten Sie die Öffnungszeiten!'
          //     });
          //     return;
          // }

          // //Prüfe den Mindestbestellwert
          // if (store.getters.cartSum < store.getters.appconfig.takeAway.minOrderAmount) {
          //     // if (store.getters.cartSum < this.minOrderAmount) {
          //     //     if (this.usecase === 'delivery') {
          //     this.$router.push({name: 'Korb'});
          //     ebus.$emit('showInfo', {
          //         title: 'Bitte beachte den Mindestbestellwert von '
          //             + util.getLocalPrice(store.getters.appconfig.takeAway.minOrderAmount)
          //     });
          //     return;
          //     // }
          // }

          //Prüfe Abholzeit
          if (this.selectedAbholDatum.value.indexOf('schlossen') > -1 ||
            !this.time.value || this.time.value.length === 0 || !this.time.utc) {
            ebus.$emit('showInfo', {
              title: 'Bitte wählen Sie eine Abholzeit aus'
            });
            return;
          }
          let dayParam = this.userSelectedHeute ? '1' : '2';
          this.pickupDate = util.generatePickupDate(dayParam, util.cloneMe(this.time));

          // this.displayPickupDate = util.displayPickupDate(pickupDate);
          // this.displayPickupDate = util.alternativeDisplayPickupDate(this.daySelected, this.time);


          // // TODO activate for captcha
          //generate CAPTCHA
          // store.commit('showLoading', true);
          // setTimeout(() => {
          //     store.commit('showLoading', false);
          // }, 2000);
          // this.generateCaptcha((responseOrFalse) => {
          store.commit('showLoading', false);
          // if (responseOrFalse) {
          //     this.renderCaptcha(responseOrFalse);

          // this.preselectCreditCard();

          // if (this.asGuest) {
          // this.lazyCreateStripeBuyer((ok) => {
          //     if (ok) {
          //         this.lazyCreatePaymentRequest();
          this.currentStep = 3;
          // if (iframe.isInIframe()) {

          // } else {
          util.delayScroll('confirmation');
          // }
          // util.jumpToTop(true);
          // }
          // });
          // }
          // } else {
          //     ebus.$emit('toast', 'Dein Netzwerk ist unterbrochen');
          //     ebus.$emit('throwError', getErrorDetails('error loading captcha');
          //     // ebus.$emit('showInfo', {
          //     //     title: 'Fehler beim Laden des Captchas',
          //     //     text: ''
          //     // });
          // }
          // } else {
          //     // ebus.$emit('showInfo', {
          //     //     title: 'Fehler beim Laden des Captchas',
          //     //     text: ''
          //     // });
          // }
          // });

        } catch (e) {
          ebus.$emit('toast', 'Dein Internet ist unterbrochen');
          this.stopLoading();
          ebus.$emit('throwError', getErrorDetails('error in finishStep2: ' + e.message));
        }
        // if (this.psp !== 'bar') {
        //     setTimeout(() => {
        //         util.delayScroll('paymentRadios');
        //     }, 900);
        // }
      });
    },

    reloadCaptcha() {
      // // store.commit('showLoading', true);
      // this.generateCaptcha((responseOrFalse) => {
      //     if (responseOrFalse) {
      //         this.renderCaptcha(responseOrFalse);
      //     }
      //     // store.commit('showLoading', false);
      // });
    },

    async renderCaptcha(arrayBuffer) {
      // // TODO activate for captcha
      // try {
      //     // Obtain a blob: URL for the image data.
      //     let arrayBufferView = new Uint8Array(arrayBuffer);
      //     let blob = new Blob([arrayBufferView], {type: "image/jpeg"});
      //     let urlCreator = window.URL || window.webkitURL;
      //     let imageUrl = urlCreator.createObjectURL(blob);
      //     let img = document.getElementById("captchaUmage");
      //     this.$nextTick(() => {
      //         img.src = imageUrl;
      //     });
      //
      //     // let img = new Image();
      //     // // let response = base64Buffer;
      //     // // let binary = '';
      //     // // for (let i = 0; i < response.length; i++) {
      //     // //     binary += String.fromCharCode(response.charCodeAt(i) & 0xff);
      //     // // }
      //     //
      //     // // img.src = 'data:image/jpeg;base64,' + btoa(binary);
      //     // img.src = 'data:image/jpeg;base64,' + base64Buffer;
      //     // let canvas = document.getElementById('captchaUmage');
      //     //
      //     // let context = canvas.getContext('2d');
      //     // this.$nextTick(() => {
      //     //     context.drawImage(img, 0, 0);
      //     // });
      // } catch (e) {
      //     ebus.$emit('throwError', getErrorDetails('error in drawCaptcha: ' + e.message);
      //     console.log('error in drawCaptcha: ' + e.message);
      // }

    },

    generateCaptcha(cb) {
      // xhr.xhrGetImage('xhr/captcha/generate',
      //     // {
      //     //     'Accept': '*/*'
      //     // },
      //     (reponseData) => {
      //         if (cb) {
      //             cb(reponseData);
      //         }
      //     },
      //     (err) => {
      //         if (cb) {
      //             cb(false);
      //         }
      //     }
      // );
    },

    saveForm() {
      try {
        let _fd = {
          name: this.name,
          email: this.email,
          phone: this.phone,
          // note: this.note,
        };
        let fd = util.cloneMe(_fd);
        let ia = this.invoiceAddress;
        if (ia && ia.street && ia.street.length > 0) {
          fd.invoiceAddress = util.cloneMe(ia);
        }
        let da = this.deliveryAddress;
        if (da && da.street && da.street.length > 0) {
          fd.deliveryAddress = util.cloneMe(da);
        }
        util.sanitizeProps(fd);
        util.removeEmptyProps(fd);
        // util.sanitizeProps(fd.invoiceAddress);
        // util.sanitizeProps(fd.deliveryAddress);
        let san = util.sanitizePhone(fd.phone);
        if (san) {
          fd.phone = san;
        }
        let sanEmail = util.sanitizeEmail(fd.email);
        if (sanEmail) {
          fd.email = sanEmail;
        }
        if (fd.email || fd.phone) {
          this.$ls.set('formData', fd);
        }

        let user = {
          name: fd.name,
          email: fd.email,
          phone: fd.phone,
        };
        util.removeEmptyProps(user);
        store.commit('user', user);

      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('error in saveForm: ' + e.message));
      }
    },

    //Abholzeit
    // finishStep3() {
    //
    //     console.log('timeSelected: ' + this.time);
    //
    //     // this.displayPickupDate = util.displayPickupDate(pickupDate);
    //     // this.displayPickupDate = util.alternativeDisplayPickupDate(this.daySelected, this.time);
    //
    //     this.currentStep = 4;
    //
    //     if (this.psp !== 'bar') {
    //         setTimeout(() => {
    //             util.delayScroll('paymentRadios');
    //         }, 900);
    //     }
    // },

    // finishStep3() {
    //     if (this.consentA && this.consentB) {
    //         this.currentStep = 4;
    //     }
    // },

    checkMobilnummer() {
      if (!isMobileOk(this.phone)) {
        // let restName = store.state.restaurantData.restaurantName;
        if (this.initialTry) {
          ebus.$emit('showInfo', {
            title: 'Mobilnummer notwendig',
            text: 'Durch Angabe deiner Mobilnummer können wir nach deiner Bestellung ' +
              +'Kontakt zu dir aufnehmen'
          });
        }
        return false;
      }
      return true;
    },

    // allowedHours(h) {
    //     let nextDay = util.getNextDay();
    //     let relevantDay = store.getters.selectedStore.openingHours['' + nextDay];
    //     // let relevantDay = store.state['day' + this.internalDaySelected];
    //     // let rNow = util.getCurrentRemoteTime();
    //     // let currentHour = rNow.getHours();
    //
    //     // if (this.internalDaySelected === '1') {
    //     // //ignore hours before now
    //     // if (h < currentHour) {
    //     //     return false;
    //     // }
    //     // }
    //
    //     //check period a
    //     let matchesA = relevantDay.a.fromHour <= h && h <= relevantDay.a.tillHour;
    //     if (matchesA) {
    //         return true;
    //     }
    //
    //     //check period b
    //     if (relevantDay.b.fromHour !== relevantDay.b.tillHour) {
    //         return relevantDay.b.fromHour <= h && h <= relevantDay.b.tillHour;
    //     }
    //     return false;
    // },

    // allowedMinutes(m) {
    //     if (m % 30 === 0) {
    //         return true;
    //     }
    //
    //     return false;
    // },

    // creditCollectPaymentMethod() {
    //     goodpayUtil.createCardElement();
    //     goodpayUtil.cardElement.mount('#card-element');
    //
    //     setTimeout(() => {
    //         this.initCreditSubmitButton();
    //     }, 600);//the mount takes a view milliseconds
    // },

    // initCreditSubmitButton() {
    //     const cardholderName = document.getElementById('cardholder-name');
    //     const cardButton = document.getElementById('card-button');
    //
    //     //always provide the customer’s name, email, billing address,
    //     // and shipping address (if available) to the credit.handleCardPayment call.
    //     cardButton.addEventListener('click', async (ev) => {
    //         //Note that credit.handleCardPayment may take several seconds to complete. During that time,
    //         // you should disable your form from being resubmitted and show a waiting indicator like a spinner.
    //         let _billing_details = {
    //             name: store.state.user.name,
    //             email: store.state.user.email
    //         };
    //         if (store.state.user.mobile) {
    //             _billing_details.mobile = store.state.user.mobile;
    //         }
    //
    //         const {paymentIntent, error} = await goodpayUtil.credit.handleCardPayment(
    //             this.clientSecret, goodpayUtil.cardElement, {
    //                 payment_method_data: {
    //                     billing_details: _billing_details
    //                 },
    //                 save_payment_method: true,
    //                 receipt_email: store.state.user.email
    //             }
    //         );
    //
    //         if (error) {
    //             // Display error.message in your UI.
    //             console.log('Payment error: ' + JSON.stringify(error));
    //         } else {
    //             // The payment has succeeded. Display a success message.
    //             console.log('Payment succeeded');
    //         }
    //     });
    // },

    doOrder() {
      if (this.wait) {
        return
      }
      this.wait = true;
      // if (this.selfServiceEnabled && this.checkMobilnummer()) {
      //   this.showSubmitButton = false;
      //   //Barzahlung
      //   this._saveOrder(0);
      // }
      this._saveOrder(0);
    },

    createCreditPaymentIntent() {
      //
      //                             /*
      //                             results in the database to
      //                              "paymentInfo" : {
      //     "amount" : 13.6,
      //     "psp" : "stripe",
      //     "itemsTotal" : 16,
      //     "deliveryFee" : 0,
      //     "paymentIntentId" : "pi_1GAJiZJjaN1KCNAM2oy9mIX1",
      //     "paymentMethodId" : "pm_1G3nKoKVLzyCJeASoujaRbYH"
      // },
      //                             */
      //
      //                             console.log('??? paymentIntent status : ' + status);
      //
      //                             if (status === 'requires_action') {
      //                                 this.handleRequiresAction();
      //                             } else if (status === 'requires_capture') {
      //
      //                                 //status requires_capture means that stripePreAuth and the order has been
      //                                 //already been saved at the server
      //
      //                                 ebus.$emit('loadLastOrders');//preload last orders
      //                                 this.usingPaymentRequest = false;
      //                                 // this.notifyInfo('Die Zahlung wurde erfolgreich autorisiert');
      //
      //                                 //save as lastOrder
      //                                 this.order.id = reply.id;
      //                                 store.commit('showLoading', false);
      //                                 this.$ls.set('lastOrder', this.order);
      //
      //                                 // ebus.$emit('orderSuccess');
      //
      //                                 this.logPurchase();
      //                                 store.commit('deleteAllCartItems');
      //                                 this.$router.replace({name: 'Bestaetigung'});
      //                                 //goto success page
      //
      //                                 // this.saveOrder();
      //                             } else {
      //                                 this.usingPaymentRequest = false;
      //                                 store.commit('showLoading', false);
      //                                 this.notifyError('Unbekannter Status: ', status);
      //                             }
      //                         });
      //                     } catch (e) {
      //                         this.notifyError('Unerwarteter Fehler');
      //                         store.commit('showLoading', false);
      //                     }
      //                 } else {
      //                     store.commit('showLoading', false);
      //                     this.usingPaymentRequest = false;
      //                     this.notifyError('Unerwateter Fehler bei der Verarbeitung deiner Bestellung. Bitte versuche es gleich nochmal.');
      //                 }
      //             }, (err) => {
      //                 store.commit('showLoading', false);
      //                 this.usingPaymentRequest = false;
      //                 console.log('??? error creating intent: ' + err);
      //                 this.notifyError('Fehler bei der Zahlungsabwicklung: ', err);
      //             })
    },


    logPurchase() {
      // let param = {
      //     currency: 'EUR',
      //     value: this.total,
      //     items: util.cloneMe(firebaseUtil.getGitemsFromCart(store.getters.cartItems)),
      //     usecase: this.usecase
      // };
      // for (let itm of store.getters.cartItems) {
      //     let isCoupon = 'nameToDisplay' in itm;
      //     if (isCoupon) {
      //         param.coupon = itm.nameToDisplay;
      //         break
      //     }
      // }
      // firebaseUtil.gevent('purchase', param);
    },


    // updateMinOrderAmount() {
    //     if (store.getters.selectedStore.minOrderAmount) {
    //         this.minOrderAmount = store.getters.selectedStore.minOrderAmount;
    //         this.fee = store.getters.selectedStore.fee;
    //     }
    // },

    // updateDeliveryFee() {
    //     this.deliveryFee = 0;
    //     this.minOrderAmount = 0;
    //     for (let area of appconfig.deliveryAreas) {
    //         if (area.plz === this.deliveryAddress.plz) {
    //             this.deliveryFee = area.fee;
    //             this.minOrderAmount = area.minOrderAmount;
    //             console.log('updateDeliveryFee deliveryFee = ' + area.fee);
    //             console.log('updateDeliveryFee minOrderAmount = ' + area.minOrderAmount);
    //             return true;
    //         }
    //     }
    //     return false;
    // },

    generateOrder() {
      try {

        if (store.getters.isKiosk) {
          //custom: auto pickupdate
          let now = Date.now() + (20 * 60 * 1000);
          this.time = {
            value: getUhrzeit(now),
            display: 'ca. ' + getUhrzeit(now) + ' Uhr',
            utc: now
          };
          this.pickupDate = generatePickupDate('2', cloneMe(this.time));
        }

        let order = {
          clientId: '' + this.$ls.get('clientId'),
          lastMenuUpdate: this.$ls.get('lastMenuUpdate'),
          // loadedStoreId: window.loadedStoreId,
          sentToPos: false,
          onlinePay: false,
          directPay: false,
          authCompleted: false,
          asGuest: !!this.asGuest,
          type: 'selfOrder',
          fuid: (firebaseUtil.getFuid() ? firebaseUtil.getFuid() : null),
          btaste: bootstrap.getBtaste(),
          domain: window.location.hostname,
          channel: 'on-the-go',
          usecase: this.usecase,
          selfServiceEnabled: this.selfServiceEnabled,
          // restaurantId: store.getters.restId,
          createdAt: Date.now(),
          //Note: delayInMinutes is irrelevant for pre-orders (asap === false)
          // delayInMinutes: store.getters.delayInMinutes,
          // expectedDelayInMinutes: store.getters.delayInMinutes,
          orderData: util.cloneMe(store.getters.cartItems),
appliedDiscounts: util.cloneMe(store.getters.appliedDiscounts),
          // company: '' + this.company,
          // userInfo: util.cloneMe(store.state.user),
          // storeId: '' + store.getters.selectedStore.filialnummer,
          pickupDate: util.cloneMe(this.pickupDate),
          abholAdresse: '' + this.abholadresse,
          targetTime: this.pickupDate.utc,
          requiresPickupNotification: !store.getters.isKiosk,
          psp: '' + this.psp,
          paymentInfo: {
            // psp: '' + this.psp,
            amount: 0 + this.total,
          },
          paymentAuth: {},
          note: '',
          // deliveryAddress: {
          //     company: '' + this.deliveryAddress.company.trim(),
          //     street: '' + this.deliveryAddress.street.trim(),
          //     plz: '' + this.deliveryAddress.plz.trim(),
          //     city: '' + this.deliveryAddress.city.trim(),
          //     etage: '' + this.deliveryAddress.etage.trim(),
          // }
        };

        if (store.getters.isKiosk) {
          order.isKiosk = true;
          order.psp = 'beiAbholung';
        }

        if (qconst.withPosApi) {
          order.posConfirmedTime = 0;
        }

        if (this.isInvoiceAddressVisible) {
          let invoiceAddress = {
            company: '' + this.invoiceAddress.company.trim(),
            street: '' + this.invoiceAddress.street.trim(),
            plz: this.invoiceAddress.plz,
            city: '' + this.invoiceAddress.city.trim(),
            // etage: '' + this.deliveryAddress.etage.trim(),
          }
          order.invoiceAddress = invoiceAddress;
        }

        // let bbnUser = store.getters.bbnUser;
        // let primaryCardId = bbnUser.primaryCardId;
        // if (primaryCardId && store.getters.loggedIn) {
        //   let card = store.getters.cards.find(c => c.rfid === primaryCardId);
        //   let bbnUser = this.$ls.get('bbnUser');
        //   if (card) {
        //     let orderExtend = {
        //       card: card,
        //       cardId: card.id,
        //     };
        //     Object.assign(order, orderExtend);
        //   }
        //   if (bbnUser) {
        //     let orderExtend = {
        //       userId: bbnUser.id,
        //       userToken: bbnUser.token,
        //     };
        //     Object.assign(order, orderExtend);
        //   }
        // }

        if (store.state.enableMehrwegOption) {
          order.mehrwegOption = !!this.mehrwegOption.aaaSelected;
          if (order.mehrwegOption) {
            order.mehrwegOptionCompanyName = '' + store.state.mehrwegOptionCompanyName;
          }
        }

        let pushToken = this.$ls.get('pushToken');
        if (pushToken) {
          order.pushToken = pushToken;
        }

        if (store.getters.enableStempel) {
          order.collectStempel = true;
          order.stempelType = store.getters.stempelType;
        }
        if (this.note) {
          order.note = '' + this.note;
        }

        order.userInfo = this.getUserInfo();

        // if (!this.sameAsInvoiceAddress) {
        //   order.deliveryAddress = {
        //     company: '' + this.deliveryAddress.company,
        //     street: '' + this.deliveryAddress.street,
        //     plz: this.deliveryAddress.plz,
        //     city: '' + this.deliveryAddress.city,
        //     etage: '' + this.deliveryAddress.etage,
        //   };
        // }//else we only submit the invoiceAddress

        util.sanitizeProps(order);

        //add app string
        // if (breakpoints.getCurrentDevice() === 'xs') {
        //     order.app = 'LIEFERMAXX Mobile App'
        // } else {
        //     order.app = 'LIEFERMAXX App'
        // }

        //add operating system
        try {
          order.userAgentData = window.navigator.userAgentData;
        } catch (e) {

        }

        // if (this.onlinePay) {
        //     // order.orderNumber = this.orderNumber;
        //     // order.uniqueOrderId = this.uniqueOrderId;
        //
        //     order.paymentInfo.psp = 'stripe';
        //     // order.paymentInfo.paymentIntentId = this.paymentIntentId;
        //     // order.paymentInfo.paymentMethodId = this.selectedPaymentMethodId;
        // }
        // if (this.usecase === 'delivery') {
        //     if (this.deliveryAddress.etage.length > 0) {
        //         order.deliveryAddress.etage = this.deliveryAddress.etage;
        //     }
        order.paymentInfo.itemsTotal = 0 + store.getters.cartSum;
        // order.paymentInfo.deliveryFee = 0;// + store.state.deliveryFee;
        //     // let fee = null;
        //     // for (let area of store.getters.appconfig.deliveryAreas) {
        //     //     if (area.plz === order.deliveryAddress.plz) {
        //     //         fee = area.fee;
        //     //         break;
        //     //     }
        //     // }
        //     // if (fee === null) {
        //     //     //error
        //     //     this.notifyError('Fehler bei den Lieferkosten');
        //     //     return null;
        //     // }
        //     // order.paymentInfo.amount = this.total;
        // } else {
        // order.pickupStore = util.cloneMe(store.getters.selectedStore);
        // delete order.pickupStore.openingHours;
        // order.storeId = '' + store.getters.selectedStore.filialnummer;
        // }
        return util.cloneAndRemoveAllDisplayKeys(order, ['delay']);
      } catch (e) {
        ebus.$emit('throwError', getErrorDetails('Exception in generateOrder: ' + e.message));
        return null;
      }
    },

    notifyError(text, err) {
      console.log('error ' + text + ' ' + err);
      ebus.$emit('info', 'Fehler! ' + text + ' ' + (err || ''));
    },

    // notifyInfo(text, err) {
    //     this.$notify({
    //         type: 'info',
    //         title: text,
    //         text: err || ''
    //     });
    // },

    // handleRequiresAction() {
    //     console.log('??? handle requires_action with usingPaymentRequest = ' + this.usingPaymentRequest);
    //
    //     if (this.usingPaymentRequest) {
    //         (async () => {
    //             const {error} = await stripeUtil.connectedAccount.handleCardPayment(this.clientSecret);
    //             this.usingPaymentRequest = false;
    //             store.commit('showLoading', false);
    //             if (error) {
    //                 // The payment failed -- ask your customer for a new payment method.
    //                 console.log('??? handleCardPayment failed');
    //                 console.log('??? handleCardPayment error: ' + JSON.stringify(error));
    //                 store.commit('showLoading', false);
    //                 this.notifyError('Fehler bei der Autorisierung der Zahlung');
    //             } else {
    //                 // The payment SCA auth has succeeded.
    //                 console.log('??? handleCardPayment succeeded');
    //                 this.saveOrder(true);
    //             }
    //         })();
    //     } else {
    //         (async () => {
    //
    //             // handleCardAction() leads to the follwing error when payment method comes from payment request button:
    //             // IntegrationError: handleCardAction: The PaymentIntent supplied does not require manual server-side confirmation.
    //             // Please use handleCardPayment instead to complete the payment.
    //
    //             const {error: errorAction, paymentIntent} =
    //                 await stripeUtil.connectedAccount.handleCardAction(this.clientSecret);
    //             this.usingPaymentRequest = false;
    //             store.commit('showLoading', false);
    //             if (errorAction) {
    //                 console.log('??? handleRequiresAction failed');
    //                 console.log('??? handleRequiresAction errorAction: ' + JSON.stringify(errorAction));
    //                 store.commit('showLoading', false);
    //                 this.notifyError('Fehler bei der Autorisierung der Zahlung');
    //                 // Show error from Stripe.js in payment form
    //             } else {
    //                 //Payment SCA auth succeeded
    //                 console.log('??? handleRequiresAction succeeded');
    //                 this.saveOrder(true);
    //                 //As authentication and other required steps occur asynchronously on the client,
    //                 // you must monitor for the payment_intent.succeeded and payment_intent.payment_failed
    //                 // events on your server in order to determine the outcome of the process and handle
    //                 // fulfillment upon success.
    //             }
    //         })();
    //     }
    //
    // }


  }
}
</script>

<style lang="scss" scoped>
@import '../styles/base';
@import '../styles/forms';

.highScreen {
  .onlyForHighScreens {
    height: 12vh;
  }
}


/*@import '../styles/sharedStyles';*/

/*.paypal-click {*/
/*    position: absolute;*/
/*    top: 10px;*/
/*    height: 56px;*/
/*    width: 100%;*/
/*    background-color: rgba(red, 0.5);*/
/*    z-index: 100;*/
/*}*/


.datefields {
  width: 70%;
  min-width: 250px;
  max-width: 350px;
}

.termin {
  margin: 8px 0 8px 8px;
}


/*@keyframes pulse {*/
/*    0% {*/
/*        transform: scale3d(1, 1, 1);*/
/*    }*/
/*    50% {*/
/*        transform: scale3d(1.05, 1.05, 1);*/
/*    }*/
/*    100% {*/
/*        transform: scale3d(1, 1, 1);*/
/*    }*/
/*}*/

.actions {

  td {
    text-align: left;
    padding: 1.5%;
  }
}

.bestelldaten {
  /*<!--background-color: $color-darkblue;-->*/

  tr {
    td:first-child {
      color: rgba(black, 0.7)
    }

    td:last-child {
      padding-left: 15px;
      /*color: black;*/
    }

  }

}

/*.vvd {*/
/*    background-color: rgba(white,0.7);*/
/*}*/

/*.page ::v-deep .v-stepper__content{*/
/*    margin-left: 33px;*/
/*}*/


</style>
